import React, { Component, Fragment } from 'react';
import { _delete, get, patch, postWithHeaders, postWithHeadersResponse, put, putWithHeadersResponse } from '../../../server/actions'
import { getActiveSchoolYearSettings } from '../ManageSchools/manageSchoolSettings';
import { currency_symbol } from '../../../server/constants';
import PropTypes from "prop-types";
import Modal from 'react-modal'
import ToggleDisplay from 'react-toggle-display';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import moment from 'moment';
import '../../../../src/assets/css/react-table.css'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import NotificationSystem from 'react-notification-system';
import Phone from 'react-phone-number-input';
import '../../../assets/css/phoneInputStyles.css'
import '../../../assets/css/rrui.css'
import { dial_code, mobileNoLength } from '../../../server/constants'
import {
    _addNotification, _addNotificationError, formatDate, allowNumericWithdecimal, convertTwoDecimalPoint,
    numberOnly, getGradeNumberByText, getModuleEnum, getAccessLevelByModule, getSchoolGrades,
    showFile
} from '../../../server/util'
import $ from "jquery";
import FreeReducedStudetsList from './freeReducedStudetsList';
import CustomSubmit from './../../Misc/customSubmit';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import _, { groupBy } from 'lodash';
const defaultImg = require('../../../assets/img/student-icon.png');
var converter = require('number-to-words');
const download = require('downloadjs');
const CheckboxTable = checkboxHOC(ReactTable);
let searchedSchool = [];
let teachers = [];
let studentsByGrade = [];
const FreeNationOptions = ['Saik’ uz', 'Stellat’ en', 'Nadleh', 'Nak’ azdli',
    'Binche', 'Burns Lake Band', 'Cheslatta', 'Lake Babine', 'McLeod Lake',
    'Nee Tahi Buhn', 'Skin Tyee', 'Takla Lake', 'Tl’ azt’ en',
    'Wet’suwet’en', 'Yekooche', 'off'];
const parentEmailsEnum = {
    primary: 'Primary email',
    alternate: 'Alternate email',
    both: 'Both emails'
}

const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

const customStyles = {
    content: {
        maxHeight: '550px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '90%',
        transform: 'translate(-50%, -50%)'
    }
};
const editStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const eligibleCheck = {
    width: '18px',
    height: '18px',
    verticalAlign: 'middle',
    margin: '5px',
    cursor: 'pointer'
};
const freeEligibleReasonStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
let teacherNames = [];
const modEnum = getModuleEnum();
let gradeList = [];
class ManageSchool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            teacherObj: {
                openTeacherModal: false,
                teacherName: ''
            },
            notifyPrefObj: {
                openNotifyPrefModal: false,
                defaultNotifyEmail: parentEmailsEnum.both
            },
            error: null,
            altError: null,
            isValidEmail: true,
            mobileLength: mobileNoLength(),
            studentsCount: 0,
            loading: false,
            deletedStudents: [],
            currentPage: 0,
            students: [],
            currentGrade: '0',
            phone: '',
            eligibilityCodes: [],
            editStudent: {
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "freezePreOrder": false,
                "parentuser": {
                    "userName": "",
                    "parentAltEmail": ""
                },
                "spendingLimit": "",
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''

            },
            updateStudent: {},
            change: {},
            studentsForm: [{
                "loggedUser": "", //get from sessionStorage or context
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",  //get from sessionStorage or context
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                "spendingLimit": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }],
            data: [],
            columns: [],
            selection: [],
            selectionStuList: {},
            selectAll: false,
            selectType: 'checkbox',
            tabIndex: 0,
            conformationModalIsOpen: false,
            schoolYearSettings: {},
            addModalIsOpen: false,
            editModalIsOpen: false,
            deleteModalIsOpen: false,
            eligModalIsOpen: false,
            eligFreeClicked: undefined,
            show: false,
            studentCount: 0,
            allStudentData: [],
            result: [],
            mealSchoolId: sessionStorage.getItem('SchoolId'),
            sLimitStatus: sessionStorage.getItem('spendingLimit'),
            freeEligibleReason: '',
            originalEligibility: {
                isReducePriceEligible: false,
                isFreeMealEligible: false,
                decisionReason: ''
            },
            pendingUpdateData: null,
            pendingUpdateType: null
        };
        this.activateStudent = this.activateStudent.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.getDataByGrade = this.getDataByGrade.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.handleChangeEditStudent = this.handleChangeEditStudent.bind(this);
        this.handleEmailChangeEditStudent = this.handleEmailChangeEditStudent.bind(this);
        this.changeFreeOrRedPrice = this.changeFreeOrRedPrice.bind(this);
        this.changeB_ACare = this.changeB_ACare.bind(this);
        this.buildDataFormatForExport = this.buildDataFormatForExport.bind(this);
    };

    previousPage = () => {
        if (this.state.currentPage !== 0)
            this.setState({ currentPage: this.state.currentPage - 1 })
    }
    nextPage = () => {
        if ((this.state.currentPage + 1) * 20 < this.state.students.length)
            this.setState({ currentPage: this.state.currentPage + 1 })
    }
    getEligibilityCodes = () => {
        const _self = this;
        get(`/eligibilityCodes/search/findByIsActive?isActive=true&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                eligibilityCodes: data._embedded.eligibilityCodes, loading: false
            });

        }).catch(
            (error) => {
                this.setState({
                    eligibilityCodes: [], loading: false
                });
                console.log('Eligibility Codes errors:', error)
            }
        )
    }
    filterSchool = () => {
        let s = document.getElementById('search').value;
        //alert(s)
        let filteredData = [];
        let filter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';
        switch (filter) {
            case 'invited':
                this.state.students.map(item => {
                    item.register ? filteredData.push(item) : '';
                });
                break;
            case 'notInvited':
                this.state.students.map(item => {
                    !item.register ? filteredData.push(item) : '';
                });
                break;
            case 'registered':
                this.state.students.map(item => {
                    item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                break;
            case 'notRegistered':
                this.state.students.map(item => {
                    !item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                break;
            case 'enrollBC&AC':
                this.state.students.map(item => {
                    item.isEnrollBCAndACPkt ? filteredData.push(item) : '';
                });
                break;
            case 'Free':
                this.state.students.map(item => {
                    item.isFreeMealEligible ? filteredData.push(item) : '';
                });
                break;
            case 'Reduced':
                this.state.students.map(item => {
                    item.isReducePriceEligible ? filteredData.push(item) : '';
                });
                break;
            case 'Regular':
                this.state.students.map(item => {
                    (!item.isFreeMealEligible && !item.isReducePriceEligible) ? filteredData.push(item) : '';
                });
                break;
            case 'BC':
                this.state.students.map(item => {
                    (item.beforeCare === true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'AC':
                this.state.students.map(item => {
                    (item.beforeCare !== true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'btnNewStudents':
                this.state.students.map(item => {
                    (item.sisNewStudent == true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            default:
                filteredData = this.state.students;
                break;
        }
        searchedSchool = [];
        if (s.length > 0) {

            filteredData.forEach(obj => {
                if (obj._id != null && (obj._id.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.teacherName != null && (obj.teacherName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            this.updateState(searchedSchool);
        }
        else {
            document.getElementById("addSchool").classList.remove("flash-button");
            this.updateState(searchedSchool.length == 0 ? filteredData : searchedSchool);
        }
        this.forceUpdate();
    };
    componentWillMount = () => {
         this.getSchoolYearSettings();
    }
    componentDidMount = () => {
        this.setState({ loading: false });
        this.getEligibilityCodes();
        this.getDataByGrade(0);
        this._notificationSystem = this.refs.notificationSystem;
    };

    getSchoolYearSettings = () => {
        getActiveSchoolYearSettings(sessionStorage.getItem('SchoolId'))
            .then((schoolYearSettings) => {
                this.setState({ schoolYearSettings });
            }).catch(
                (error) => {
                    console.log('Get manage school response', error)
                }
            );
        }

    handleFirstNameChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, firstName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleLastNameChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, lastName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleAddressChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, numberStreetApt: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleZipChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, cityStateZip: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleCardCheckboxChange = (evt, idx) => {

        let studentList = this.state.studentsForm;
        studentList[idx][evt.target.name] = evt.target.checked ? true : false;
        this.setState({ studentsForm: studentList });
    };
    handleIdChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, studentId: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleGradeChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, gradeName: evt.target.value };
        });

        this.setState({ studentsForm: newStudent });
    };
    handleTeacherChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, teacherName: evt.target.value };
        });
        this.setState({ studentsForm: newStudent });
    };
    isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }
    handleMailChange = (idx) => (evt) => {
        if (!this.isValidEmail(evt.target.value)) {
            this.setState({ error: 'Email is invalid' });
        } else {
            this.setState({ error: null });
        }
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.parentuser.userName = evt.target.value;
            return obj;

        });

        this.setState({ studentsForm: newStudent });
    };
    handleAltMailChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.parentuser.parentAltEmail = evt.target.value;
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    };
    handleMobileNoChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, mobileNo: evt.target.value };//Adding National formatting)
        });
        this.setState({ studentsForm: newStudent });
    }
    handleSpendingLimit = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            return { ...student, spendingLimit: evt.target.value };
        });
        this.setState({ studentsForm: newStudent });
    };
    handleReducePriceChange = (idx) => (evt) => {

        if (document.getElementById("isReducePriceEligible" + idx).checked) {
            document.getElementById("isFreeMealEligible" + idx).checked = false;
        }

        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj[evt.target.name] = evt.target.checked;
            obj["isFreeMealEligible"] = false;
            obj['decisionReason'] = '';
            obj['category'] = '';
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    }

    handleFreeMealChange = (idx) => (evt) => {
        if (document.getElementById("isFreeMealEligible" + idx).checked) {
            document.getElementById("isReducePriceEligible" + idx).checked = false;
        }

        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj[evt.target.name] = evt.target.checked;
            obj["isReducePriceEligible"] = false;
            obj['decisionReason'] = '';
            obj['category'] = '';
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    }


    handleAddStudent = () => {
        this.setState({
            studentsForm: this.state.studentsForm.concat([{
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": '',
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }])
        });
    };
    handleRemoveStudent = (idx) => () => {
        this.setState({
            studentsForm: this.state.studentsForm.filter((s, sidx) => idx !== sidx)
        });
    };
    handleDefaultEmailNotifyChange = (idx) => (evt) => {
        const newStudent = this.state.studentsForm.map((student, sidx) => {
            if (idx !== sidx) return student;
            var obj = { ...student };
            obj.defaultNotifyEmail = evt.target.value;
            return obj;
        });

        this.setState({ studentsForm: newStudent });
    };
    onStudentDataSubmit = (event, callback) => {
        let schoolId = sessionStorage.getItem('SchoolId');
        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let students = [];
        let invalidMobileNos = [];
        this.state.studentsForm.map((student, k) => {
            if (student.mobileNo.length !== 0 && student.mobileNo.length < this.state.mobileLength) {
                invalidMobileNos.push(k);
            }
            students.push({
                "loggedUser": loggedUser,
                "firstName": student.firstName,
                "lastName": student.lastName,
                "gradeName": student.gradeName,
                "studentId": student.studentId,
                "mobileNo": student.mobileNo.length > 0 ? (dial_code() + student.mobileNo) : '',
                "teacherName": student.teacherName,
                "decisionReason": student.decisionReason,
                "category": student.category,
                "isReducePriceEligible": student.isReducePriceEligible,
                "isFreeMealEligible": student.isFreeMealEligible,
                "defaultNotifyEmail": student.defaultNotifyEmail,
                "spendingLimit": student.spendingLimit,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "parentuser": {
                    "loggedUser": loggedUser,
                    "userName": student.parentuser.userName,
                    "parentAltEmail": student.parentuser.parentAltEmail
                },
                "numberStreetApt": student.numberStreetApt,
                "cityStateZip": student.cityStateZip,
                hasMilkCard: student.hasMilkCard,
                beforeCare: student.beforeCare,
                additionalNotes: student.additionalNotes,
                actualPrg: student.actualPrg
            });
        });

        if ((students[0].firstName || '').trim() === '') {
            _addNotificationError('Please enter student first name.', this);
            callback(true);
            return false;

        }

        if ((students[0].lastName || '').trim() === '') {
            _addNotificationError('Please enter student last name.', this);
            callback(true);
            return false;
        }
        if ((students[0].studentId || '').trim() === '') {
            _addNotificationError('Please enter student Id.', this);
            callback(true);
            return false;
        }
        if ((students[0].gradeName || '').trim() === '') {
            _addNotificationError('Please select grade.', this);
            callback(true);
            return false;
        }
        if ((students[0].parentuser.userName || '').trim() === '') {
            _addNotificationError('Please enter parent primary email.', this);
            callback(true);
            return false;
        }

        if (this.state.error) {
            _addNotificationError('Please enter valid parent primary email.', this);
            callback(true);
            return false;
        }
        if (students[0].isReducePriceEligible && (students[0].category || '') == '') {
            _addNotificationError('Please Select Reduced Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (students[0].isFreeMealEligible && (students[0].category || '') == '') {
            _addNotificationError('Please Select Free Eligibility Code.', this);
            callback(true);
            return false;
        }
        if (students[0].isFreeMealEligible && students[0].category == 'Free (TANF,SNAP,Foster)' && (students[0].actualPrg || '') === '') {
            _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
            callback(true);
            return false;
        }
        if (students[0].isFreeMealEligible && students[0].category == 'First Nation' && (students[0].actualPrg || '') === '') {
            _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
            callback(true);
            return false;
        }

        if (invalidMobileNos.length > 0) {
            _addNotificationError('Please Provide valid mobile numbers.', this);
            callback(true);
            event.preventDefault();
            return false;
        } else {
            let headers = {
                'Content-Type': 'application/json'
            };
            if (students.length > 0) {
                postWithHeadersResponse('/students?mealSchoolId=' + schoolId + '&access_token=', JSON.stringify(students), headers).then((response) => {
                    if (response.statusCode !== 200) {
                        throw Error(response.statusMessage);
                    }
                    return response;
                }).then(data => {
                    this.setState({ addModalIsOpen: false });
                    this.setState({
                        studentsForm: [{
                            "firstName": "",
                            "lastName": "",
                            "gradeName": "",
                            "studentId": "",
                            "mobileNo": "",
                            "teacherName": '',
                            "decisionReason": '',
                            "category": '',
                            "isReducePriceEligible": false,
                            "isFreeMealEligible": false,
                            "defaultNotifyEmail": parentEmailsEnum.both,
                            "schoolYear": '',
                            "parentuser": {
                                "loggedUser": "",
                                "userName": "",
                                "parentAltEmail": ""
                            },
                            "numberStreetApt": "",
                            "cityStateZip": "",
                            hasMilkCard: false,
                            beforeCare: false,
                            additionalNotes: '',
                            actualPrg: ''
                        }]
                    });
                    this.getDataByGrade(this.state.tabIndex);
                    _addNotification('Students Added Successfully.', this);
                    callback(true);
                    //alert('Students Added Succesfully');
                }).catch(
                    (error) => {
                        _addNotificationError(error.message, this);
                        callback(true);
                        console.log('Cannot save students', error)
                    }
                );
            }
        }
        event.preventDefault();
    };
    handleEmailChangeEditStudent = (e) => {
        if (!this.isValidEmail(e.target.value)) {
            this.setState({ error: 'Email is invalid' });
        } else {
            this.setState({ error: null });
        }
        if (e.target.name === 'parentEmailId') {
            this.state.editStudent.parentuser.userName = e.target.value;
        }
        this.forceUpdate();
        // this.setState({editStudent: this.state.editStudent});
    };

    handleChangeEditStudent = (e) => {
        if (e.target.name === 'parentAltEmail') {
            this.state.editStudent.parentuser.parentAltEmail = e.target.value;
        }
        this.state.editStudent[e.target.name] = e.target.value;
        this.forceUpdate();
        // this.setState({editStudent: this.state.editStudent});
    };
    handleCardCheckboxEditChange = (e) => {
        let _editStudent = this.state.editStudent;
        _editStudent[e.target.name] = e.target.checked ? true : false;
        this.setState({ editStudent: _editStudent });
    }
    handleDefaultEmailNotifyEditChange = (e) => {
        this.state.editStudent['defaultNotifyEmail'] = e.target.value;
        this.forceUpdate();
    };

    handleEditMobileNo = (e) => {
        this.state.editStudent.mobileNo = e.target.value;
        this.forceUpdate();

    }
    handleEditSpendingLimit = (e) => {
        this.state.editStudent.spendingLimit = e.target.value;
        this.forceUpdate();

    }
    handleTeachersEdit = () => {
        document.getElementById('teacherNameEdit').value = '';
    };

    handleEditReducePrice = (e) => {
        console.log(e.target);
        if (document.getElementById("isReducePriceEligible").checked) {
            document.getElementById("isFreeMealEligible").checked = false;
        }

        this.state.editStudent[e.target.name] = e.target.checked;
        this.state.editStudent["isFreeMealEligible"] = false;
        this.state.editStudent['decisionReason'] = '';
        this.state.editStudent['category'] = '';
        this.state.editStudent['actualPrg'] = '';
        this.forceUpdate();

    }

    handleEditFreeMeal = (e) => {
        console.log(e.target);
        if (document.getElementById("isFreeMealEligible").checked) {
            document.getElementById("isReducePriceEligible").checked = false;
        }
        this.state.editStudent[e.target.name] = e.target.checked;
        this.state.editStudent["isReducePriceEligible"] = false;
        this.state.editStudent['decisionReason'] = '';
        this.state.editStudent['category'] = '';
        this.state.editStudent['actualPrg'] = '';

        this.forceUpdate();

    }


    activateStudent(student) {
        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let body = JSON.stringify({
            "isActive": true,
            loggedUser: loggedUser,
            modifiedOn: moment().utc()
        });
        let studentId = student._links.self.href.split('/').pop();
        put('/changeStdStatus/' + studentId + '?isActive=true&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.getDataByGrade(this.state.tabIndex);
            this.getDeletedStudents();
            _addNotification('Successfully restored students data.', this);

        }).catch(
            (error) => {
                _addNotificationError('Unable to Restore ! Try Again.', this);
                console.log('Restore students data response', error)
            }
        );
    }
    exportStudents = () => {
        const _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        let urlParm = '';
        let filter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';
        switch (filter) {
            case 'invited':
                urlParm = '?isInvited=true&access_token=';
                break;
            case 'notInvited':
                urlParm = '?isNotInvited=true&access_token=';
                break;
            case 'registered':
                urlParm = '?isRegister=true&access_token=';
                break;
            case 'notRegistered':
                urlParm = '?isNotRegister=true&access_token=';
                break;
            case 'enrollBC&AC':
                urlParm = '?isEnrollBCAndACPkt=true&access_token=';
                break;
            case 'Free':
                urlParm = '?isFreeMealEligible=true&access_token=';
                break;
            case 'Reduced':
                urlParm = '?isReducePriceEligible=true&access_token=';
                break;
            case 'Regular':
                urlParm = '?isRegular=true&access_token=';
                break;
            case 'BC':
                urlParm = '?isBeforeCare=true&access_token=';
                break;
            case 'AC':
                urlParm = '?isAfterCare=true&access_token=';
                break;
            default:
                urlParm = '?access_token=';
                break;
        }

        get(`/${schoolId}/studentsExport/${sessionStorage.getItem('schoolYearValue')}${urlParm}`).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = 'Students data';
            download(blob,
                filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                this.setState({ loading: false })
                //console.log('Get Excel File response', error)
            }
        )
    }

    getDeletedStudents() {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=false&schoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                deletedStudents: data._embedded.studentUsers,
            })
        }).catch(
            (error) => {
                console.log('Get deleted students data response', error)
            }
        );
    }

    handleClick() {
        this.getDeletedStudents();
        this.setState({
            show: !this.state.show
        })

    }

    isEligibilityDowngrade(newFree, newReduced) {
        const currentFree = this.state.editStudent.isFreeMealEligible;
        const currentReduced = this.state.editStudent.isReducePriceEligible;
        
        // Free → Reduced (downgrade)
        if (currentFree && !newFree && newReduced) return true;
        // Free → Regular/Paid (both false) (downgrade)
        if (currentFree && !newFree && !newReduced) return true;
        // Reduced → Regular/Paid (downgrade)
        if (currentReduced && !newReduced && !newFree) return true;
        
        return false;
    }

    hasEligibilityChanged() {
        const statusChanged = (
            this.state.editStudent.isReducePriceEligible !== this.state.originalEligibility.isReducePriceEligible ||
            this.state.editStudent.isFreeMealEligible !== this.state.originalEligibility.isFreeMealEligible
        );
        
        const codeChanged = (
            this.state.editStudent.decisionReason !== this.state.originalEligibility.decisionReason
        );
        
        return statusChanged || codeChanged;
    }

    isStudentEligibilityDowngrade() {
        const currentFree = this.state.originalEligibility.isFreeMealEligible;
        const currentReduced = this.state.originalEligibility.isReducePriceEligible;
        const newFree = this.state.editStudent.isFreeMealEligible;
        const newReduced = this.state.editStudent.isReducePriceEligible;

        // Free → Reduced (downgrade) and validation for reason code change when eligibility is reduced
        if (currentFree && !newFree && newReduced) return true;
        // Free → Regular/Paid (both false) (downgrade)
        if (currentFree && !newFree && !newReduced) return true;
        // Reduced → Regular/Paid (downgrade)
        if (currentReduced && !newReduced && !newFree) return true;

        return false;
    }

    isMultiStudentEligibilityDowngrade(currentStatus, newStatus) {
        // currentStatus: 'Free', 'Reduced', or 'Regular'
        // newStatus: 'Free', 'Reduced', or 'Regular'
        
        if (currentStatus === 'Free' && (newStatus === 'Reduced' || newStatus === 'Regular')) return true;
        if (currentStatus === 'Reduced' && newStatus === 'Regular') return true;
        return false;
    }

    openModal(stateObj, col) {
        if (stateObj === "deleteModalIsOpen") {
            let data = col;
            this.setState({ editStudent: data });
        }
        else if (stateObj === "editModalIsOpen") {
            //alert('came here')
            console.log('data of edit', col);
            let mobileNo = col.mobileNo || '';
            mobileNo = mobileNo.substr(-this.state.mobileLength);
            let data = JSON.parse(JSON.stringify(col));
            data.defaultNotifyEmail = data.defaultNotifyEmail || parentEmailsEnum.both;
            data.parentuser.parentAltEmail = ((data.parentuser.parentAltEmail == 'N/A' || data.parentuser.parentAltEmail == 'NA') ? undefined : data.parentuser.parentAltEmail)
            data.mobileNo = mobileNo;
            data.image = (data.image || '') === '' ? defaultImg : data.image;
            console.log('data of edit', data);
            this.setState({ 
                editStudent: data,
                originalEligibility: {
                    isReducePriceEligible: data.isReducePriceEligible,
                    isFreeMealEligible: data.isFreeMealEligible,
                    decisionReason: data.decisionReason || ''
                }
            });
        }
        this.setState({ [stateObj]: true });
    }

    afterOpenModal() {
    }

    closeModal(stateObj) {
        this.setState({ [stateObj]: false });
        this.setState({
            studentsForm: [{
                "loggedUser": "",
                "firstName": '',
                "lastName": '',
                "studentId": '',
                "gradeName": '',
                "mobileNo": "",
                "teacherName": '',
                "decisionReason": '',
                "category": '',
                "isReducePriceEligible": false,
                "isFreeMealEligible": false,
                "defaultNotifyEmail": parentEmailsEnum.both,
                "schoolYear": '',
                "parentuser": {
                    "loggedUser": "",
                    "userName": "",
                    "parentAltEmail": ""
                },
                "numberStreetApt": "",
                "cityStateZip": "",
                hasMilkCard: false,
                beforeCare: false,
                additionalNotes: '',
                actualPrg: ''
            }]
        });
        this.getDataByGrade(this.state.tabIndex);
        // console.log('change', this.state.editStudent);
    }

    filterStudents(e) {
        this.state.currentGrade = e.target.value;
        //this.getSchoolData();
    }

    updateState(newState) {
        if (newState.length === 0) {
            document.getElementById("addSchool").classList.add("flash-button");
        } else {
            document.getElementById("addSchool").classList.remove("flash-button");
        }
        this.setState({ data: newState });
    }


    deleteStudent(e, callback) {
        const _self = this;
        let recId = this.state.editStudent._links.self.href.split('/').pop();
        let headers = {
            'Content-Type': 'application/json'
        };

        let loggedUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let loggedUser = loggedUserInfo.username;
        let body = JSON.stringify({
            "isActive": false,
            loggedUser: loggedUser,
            modifiedOn: moment().utc()
        });
        putWithHeadersResponse('/changeStdStatus/' + recId + '?isActive=false&access_token=', undefined, headers).then((response) => {
            if (!response.ok) {
                throw response.text();
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            this.setState({ deleteModalIsOpen: false })
            callback(true);
            this.getDataByGrade(this.state.tabIndex);

        }).catch(err => {
            err.then(error => {
                _addNotificationError(JSON.parse(error).statusMessage, _self);
                callback(true);
                _self.setState({ deleteModalIsOpen: false })
            })
        });
    }

    getColumns(data) {
        console.log('data for get cols', data);
        let columns = [];
        let header = ['First Name', 'Last Name', 'Teacher Name', 'Parent EmailId', 'Parent MobileNo', 'Actions'];
        if (data.length === 0) {

            header.map(key =>
                columns.push({ Header: key }));

        }
        else {
            columns.push({
                accessor: 'fullName',
                id: "fullName",
                Header: 'Name',
                sortable: true,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'studentId',
                Header: 'Student Id',
                Cell: props => <span>{props.original.studentId}</span>,
                style: { textAlign: 'center' }
            })
            columns.push({
                accessor: 'teacherName',
                Header: 'Teacher Name',
                style: { textAlign: 'center' }
            });
            if (getAccessLevelByModule(modEnum.MKA)) {
                columns.push({
                    accessor: 'allergies',
                    Header: 'Allergies',
                    style: { textAlign: 'center', verticalAlign: 'middle' },
                    Cell: (props) => (
                        <Fragment>
                            <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                data-tip data-for={'std-' + props.index}>
                                {props.value}</a>
                            <ReactTooltip id={'std-' + props.index} aria-haspopup='true' type="dark" effect="float">
                                <div>
                                    {props.value}
                                </div>
                            </ReactTooltip>
                        </Fragment>
                    )
                });
            }
            columns.push({
                accessor: 'parentuser.userName',
                Header: 'PARENT EMAILID',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'mobileNum', // formatted mobile num for display
                Header: 'PARENT MOBILENO',
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'grade',
                Header: 'GRADE',
                style: { textAlign: 'center', textTransform: 'capitalize' },
                Cell: (props) => {
                    return <span>{props.original.grade}</span>
                },
                width: 75,
                show: this.state.tabIndex === 0 ? true : false
            });
            columns.push({
                accessor: 'pin',
                Header: 'PIN',
                style: { textAlign: 'center', textTransform: 'capitalize' },
                width: 75,
                show: this.state.tabIndex === 0 ? false : true
            });
            columns.push({
                id: 'actionButton',
                accessor: "studentId",
                Header: 'ACTIONS',
                style: { textAlign: 'center' }, // className: "actions text-center"
                width: 120,
                Cell: ({ row }) => (<div>
                    <a title="Edit student info" onClick={() => this.openModal("editModalIsOpen", row._original)}><i
                        className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" style={{ width: '23px', height: '23px', margin: '2px' }} /></a>
                    <a title="Delete student info" onClick={() => this.openModal('deleteModalIsOpen', row._original)}><i
                        className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" style={{ width: '23px', height: '23px', margin: '2px' }} /></a>
                    {
                        getAccessLevelByModule(modEnum.PR) ?
                            <a title="Send link to parent" onClick={() => this.sendNotification('single', row._original, () => { })}>
                                {row._original.register ? <i className="fa fa-paper-plane-o tbl-rounded-icon btn-warning fa-icon" style={{ width: '23px', height: '23px', margin: '2px' }} /> : <i className="fa fa-paper-plane-o tbl-rounded-icon bg-color-2 fa-icon" style={{ width: '23px', height: '23px', margin: '2px' }} />}</a>
                            : null}
                    {/*  {
                        getAccessLevelByModule(modEnum.LETM)?
                        <a title="Fill Application" onClick={() => {
                            this.context.router.history.push({ 
                                pathname: '/schoolAdmin/newSchoolMealProgram',
                                state: {...row._original}
                            });
                        }}>
                        <i className="fa fa-file-text tbl-rounded-icon btn-warning fa-icon" style={{width:'23px',height:'23px', margin:'2px'}} /> </a>
                    :null
                    } */}
                </div>),
            });

        }
        return columns;
    }




    getDataByGrade(gradeName) {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        let selectedFilter = document.getElementById('selector').querySelectorAll(".active")[0].getAttribute("name") || '';

        (get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))
            .then((response) => {
                console.log("API CALL RUN");
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log("allStudentData", this.state.allStudentData);
                console.log('data', data);
                const stData = data['_embedded']['studentUsers'];
                this.setState({ studentsCount: stData.length });
                console.log('stData', stData);
                console.log('student data', stData);
                const gradesGroup = groupBy(getSchoolGrades(), 'value');
                if ((gradeName || '0') == '0') {
                    return stData.map(item => {
                        let _id = item.studentId;
                        item.fullName = item.lastName + ', ' + item.firstName;
                        item.grade = ((gradesGroup[item.gradeName] || [])[0] || {}).label || '';
                        teachers.push(item.teacherName);
                        let mobileNum = item.mobileNo || ''
                        return {
                            _id,
                            mobileNum,
                            ...item
                        };
                    });

                }
                else {
                    stData.map(item => { //pushes all students for grade selected into an array
                        let _gradeName = item.gradeName;

                        if (_gradeName === gradeName) {
                            item.grade = ((gradesGroup[item.gradeName] || [])[0] || {}).label || '';
                            studentsByGrade.push(item);
                        }
                    });
                    return studentsByGrade.map(item => {

                        let _id = item.studentId;
                        item.fullName = item.lastName + ', ' + item.firstName
                        teachers.push(item.teacherName);
                        let mobileNum = item.mobileNo || '';
                        return {
                            _id,
                            mobileNum,
                            ...item
                        };
                    });

                }
                this.filterSchool();
            }).then(data => {
                console.log("Students by grade ", studentsByGrade);
                this.setState({ studentsCount: studentsByGrade.length });
                console.log('Successfully got school data', data);
                let columns = this.getColumns(data);
                if (gradeName === 0) {
                    teacherNames = [...new Set(teachers)]
                }
                console.log('teacherNames', teacherNames);
                this.setState({
                    students: data,
                    data: data,
                    columns: columns,
                    loading: false,
                    studentCount: data.length
                })
                this.filterSchool();
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)

                }
            );

    }
    changeB_ACare = (isBeforeCare, callback) => {
        let selectedRows = this.state.selection;
        this.setState({ loading: true });
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "isFreeLunch": null,
                "isBeforeCare": isBeforeCare
            };
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "gradeName": this.state.tabIndex,
                "isFreeLunch": null,
                "isBeforeCare": isBeforeCare
            };
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = {
                    "schoolId": schoolId,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "isFreeLunch": null,
                    "isBeforeCare": isBeforeCare,
                    "studentIds": selectedRows
                }
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders('/freeReducedLunchEligUpdate?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {

                this.setState({ loading: false, selection: [], selectionStuList: {}, selectAll: false });
                let _message = isBeforeCare ? 'Successfully updated before care status.' : 'Successfully updated after care status.'
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );

    }
    onUpdateTeachers = (source, callback) => {
        let data = {};
        let selectedRows = this.state.selection;
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "teacherName": this.state.teacherObj.teacherName
            };
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            /*  const selectedGrade = gradeList.find((item) => {
                 return this.state.tabIndex == item.value;
             }); */

            data = {
                "grade": this.state.tabIndex,
                // gradeName: selectedGrade.label,
                "teacherName": this.state.teacherObj.teacherName
            };
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = {
                    "studentIds": selectedRows,
                    "teacherName": this.state.teacherObj.teacherName
                }
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        if (source == "updateTeacher") {
            const { teacherObj } = this.state;
            teacherObj.openTeacherModal = true;
            this.setState({ teacherObj });
            callback(true);
        } else {
            this.onUpdateTeacherApi(data, callback);
        }
    }
    onUpdateTeacherApi = (reqObj, callback) => {
        const { teacherObj } = this.state;
        let schoolId = sessionStorage.getItem('SchoolId');
        let headers = {
            'Content-Type': 'application/json'
        };
        const url = `/manageStudents/teacher/${schoolId}/${sessionStorage.getItem('schoolYearValue')}?access_token=`
        putWithHeadersResponse(url, JSON.stringify(reqObj), headers).then((response) => {
            if (response.status === 200) {
                teacherObj.openTeacherModal = false;
                teacherObj.teacherName = ''
                this.setState({
                    loading: false,
                    selection: [],
                    selectionStuList: {},
                    selectAll: false,
                    teacherObj
                });
                let _message = 'Successfully updated teacher name.';
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to update teacher name ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );
    }
    onUpdateNotifyPreference = (source, callback) => {
        const { selectionStuList } = this.state;
        const selectedKeys = Object.keys(selectionStuList || {});
        if (selectedKeys.length === 0) {
            _addNotificationError('Please select atleast one student.', this);
            this.setState({ loading: false });
            callback(true);
            return false;
        }
        if (source == "updateNotifyPreference") {
            const { notifyPrefObj } = this.state;
            notifyPrefObj.openNotifyPrefModal = true;
            this.setState({ notifyPrefObj });
            callback(true);
        } else {
            const data = selectedKeys.map((key) => {
                return {
                    "studentUserId": selectionStuList[key].id,
                    "notificationPreference": this.state.notifyPrefObj.defaultNotifyEmail
                };
            });
            this.onUpdateNotifyPreferenceApi(data, callback);
        }
    }
    onUpdateNotifyPreferenceApi = (reqObj, callback) => {
        const { notifyPrefObj } = this.state;
        this.setState({ loading: true });
        let headers = {
            'Content-Type': 'application/json'
        };
        const url = `/manageStudents/preferences?access_token=`;
        putWithHeadersResponse(url, JSON.stringify(reqObj), headers).then((response) => {
            if (response.status === 200) {
                notifyPrefObj.openNotifyPrefModal = false;
                notifyPrefObj.defaultNotifyEmail = parentEmailsEnum.both;
                this.setState({
                    loading: false,
                    selection: [],
                    selectionStuList: {},
                    selectAll: false,
                    notifyPrefObj
                });
                let _message = `Successfully updated notification preference for ${reqObj.length} student(s).`;
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false })
                _addNotificationError('Failed to update notification preference ! Try again.', this);
                callback(true);
                console.log('Update Notification Preference Error', error)
            }
        );
    }
    showFreeOrRedConform = (isFreeLunch, callback) => {
        let selectedRows = this.state.selection;
        console.log("Selected:::::", selectedRows);
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "isFreeLunch": isFreeLunch
            };
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            data = {
                "schoolId": schoolId,
                "schoolYear": sessionStorage.getItem('schoolYearValue'),
                "gradeName": this.state.tabIndex,
                "isFreeLunch": isFreeLunch
            };
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = {
                    "schoolId": schoolId,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "isFreeLunch": isFreeLunch,
                    "studentIds": selectedRows
                }
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        this.setState({ eligFreeClicked: isFreeLunch, eligModalIsOpen: true }, () => callback(true));
    }
    changeFreeOrRedPrice(isFreeLunch, callback) {
        let selectedRows = this.state.selection;
        let schoolId = sessionStorage.getItem('SchoolId');
        if (isFreeLunch) {
            if ((this.state.freeEligibleReason || '').length == 0) {
                _addNotificationError('Please Provide Free Eligible Reason', this);
                callback(true);
                return false;
            }
        }
        
        let newStatus = isFreeLunch == true ? 'Free' : (isFreeLunch == false ? 'Reduced' : 'Regular')
        
        // Check if this is a downgrade for selected students
        let hasDowngrade = false;
        if (this.state.data && this.state.data.length > 0) {
            // Get current status of selected students
            const selectedStudentIds = this.state.selection || [];
            for (let student of this.state.data) {
                if (selectedStudentIds.includes(student.studentId)) {
                    let currentStatus = 'Regular';
                    if (student.isFreeMealEligible) currentStatus = 'Free';
                    else if (student.isReducePriceEligible) currentStatus = 'Reduced';
                    
                    if (this.isMultiStudentEligibilityDowngrade(currentStatus, newStatus)) {
                        hasDowngrade = true;
                        break;
                    }
                }
            }
        }
        
        if (hasDowngrade && this.state.schoolYearSettings.adverseActionProcedure) {
            // Show confirmation modal only if adverse action procedure is enabled
            this.setState({
                conformationModalIsOpen: true,
                pendingUpdateType: 'bulkEligibilityUpdate',
                pendingUpdateData: { 
                    isFreeLunch,
                    callback
                }
            });
            return false;
        }
        
        // If no downgrade or adverseActionProcedure is disabled, proceed with update
        this.performBulkEligibilityUpdate(isFreeLunch, callback);
    }

    performBulkEligibilityUpdate(isFreeLunch, callback) {
        let selectedRows = this.state.selection;
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        
        let data = {
            studentIds: undefined,
            grade: undefined,
            freeEligDecisionReason: undefined
        }
        let eligStatus = isFreeLunch == true ? 'Free' : (isFreeLunch == false ? 'Reduced' : 'Regular')
        
        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data.studentIds = this.state.selection || [];
            data.freeEligDecisionReason = this.state.freeEligibleReason;
        }
        else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
            data.grade = this.state.tabIndex;
            data.freeEligDecisionReason = this.state.freeEligibleReason;
        } else {
            selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data.studentIds = selectedRows || [];
                data.freeEligDecisionReason = this.state.freeEligibleReason;
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        
        let headers = {
            'Content-Type': 'application/json'
        };
        const url = `/manageStudents/eligibility/${schoolId}/${sessionStorage.getItem('schoolYearValue')}/${eligStatus}?access_token=`
        putWithHeadersResponse(url, JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ 
                    loading: false, 
                    selection: [], 
                    selectionStuList: {}, 
                    selectAll: false, 
                    eligFreeClicked: undefined, 
                    eligModalIsOpen: false,
                    conformationModalIsOpen: false,
                    pendingUpdateType: null,
                    pendingUpdateData: null
                });
                let _message = isFreeLunch ? 'Succesfully updated free lunch eligibility status.' : 'Succesfully updated reduced price lunch eligibility status.'
                _addNotification(_message, this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ 
                    loading: false, 
                    eligFreeClicked: undefined, 
                    eligModalIsOpen: false,
                    conformationModalIsOpen: false,
                    pendingUpdateType: null,
                    pendingUpdateData: null
                })
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );
    }

    sendNotification(action, row, callback) {
        console.log("sendNotification RUN");
        this.setState({ loading: true })
        let selectedRows = [];
        let data = {};
        let schoolId = sessionStorage.getItem('SchoolId');
        if (action === 'single') {
            selectedRows = [row.studentId];
            data = {
                "schoolId": schoolId,
                "notificationType": "Registration",
                "studentIds": selectedRows,
                "sendStatus": "true",
                "schoolYear": sessionStorage.getItem('schoolYearValue')
            }
        }
        else if (action === 'multiple') {
            if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
                data = {
                    "schoolId": schoolId,
                    "notificationType": "Registration",
                    "sendStatus": "true",
                    "schoolYear": sessionStorage.getItem('schoolYearValue')
                }
            }
            else if (this.state.selectAll && this.state.tabIndex !== 0 && this.state.studentCount === (this.state.selection).length) {
                data = {
                    "schoolId": schoolId,
                    "notificationType": "Registration",
                    "gradeName": this.state.tabIndex,
                    "schoolYear": sessionStorage.getItem('schoolYearValue'),
                    "sendStatus": "true"
                }
            }
            else {
                selectedRows = this.state.selection;
                if (selectedRows.length !== 0) {
                    data = {
                        "schoolId": schoolId,
                        "notificationType": "Registration",
                        "studentIds": selectedRows,
                        "schoolYear": sessionStorage.getItem('schoolYearValue'),
                        "sendStatus": "true"
                    }
                } else {
                    _addNotificationError('Please select students to send link.', this);
                    callback(true);
                }
            }
        }
        let headers = {
            'Content-Type': 'application/json'
        };

        postWithHeaders('/sendNotificationParents?access_token=', JSON.stringify(data), headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })
                _addNotification('Registration invite has been successfully sent!!', this);
                callback(true);
                this.getDataByGrade(this.state.tabIndex);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
        }).catch(
            (error) => {
                this.setState({ loading: false });
                _addNotificationError('Failed to send link ! Try again.', this);
                callback(true);
                console.log('Send Notification Error', error)
            }
        );
    }

    onUpdateStudentSubmit(event, callback) {
        event.preventDefault();
        console.log('edit student', this.state.editStudent);
        if ((this.state.editStudent.firstName || '').trim() === '') {
            _addNotificationError('Please enter student first name.', this);
            callback(true);
            return false;
        }
        if ((this.state.editStudent.lastName || '').trim() === '') {
            _addNotificationError('Please enter student last name.', this);
            callback(true);
            return false;
        }
        if ((this.state.editStudent.studentId || '').trim() === '') {
            _addNotificationError('Please enter student Id.', this);
            callback(true);
            return false;
        }
        if ((this.state.editStudent.gradeName || '').trim() === '') {
            _addNotificationError('Please select grade.', this);
            callback(true);
            return false;
        }
        if ((this.state.editStudent.parentuser.userName || '').trim() === '') {
            _addNotificationError('Please enter parent primary email.', this);
            callback(true);
            return false;
        }
        if (this.state.error) {
            _addNotificationError('Please enter valid parent primary email.', this);
            callback(true);
            return false;
        }
        if (this.state.editStudent.mobileNo.length !== 0 && this.state.editStudent.mobileNo.length < this.state.mobileLength) {
            _addNotificationError('Please Provide valid mobile number.', this);
            callback(true);
            return false;
        }
        if (getAccessLevelByModule(modEnum.LETM)) {
            if (this.state.editStudent.isReducePriceEligible && (this.state.editStudent.category || '') == '') {
                _addNotificationError('Please Select Reduced Eligibility Code.', this);
                callback(true);
                return false;
            }
            if (this.state.editStudent.isFreeMealEligible && (this.state.editStudent.category || '') == '') {
                _addNotificationError('Please Select Free Eligibility Code.', this);
                callback(true);
                return false;
            }
            if (this.state.editStudent.isFreeMealEligible && this.state.editStudent.category == 'Free (TANF,SNAP,Foster)' && (this.state.editStudent.actualPrg || '') === '') {
                _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
                callback(true);
                return false;
            }
            if (this.state.editStudent.isFreeMealEligible && this.state.editStudent.category == 'First Nation' && (this.state.editStudent.actualPrg || '') === '') {
                _addNotificationError('Please Select Free Eligibility Student Specific Program.', this);
                callback(true);
                return false;
            }
        }
        
        // Additional downgrade validation: if downgrade to Reduced, require eligibility code before confirmation
        if (this.isStudentEligibilityDowngrade() && this.state.schoolYearSettings.adverseActionProcedure) {
            if (this.state.editStudent.isReducePriceEligible && !(this.state.editStudent.category || '').trim()) {
                _addNotificationError('Please Select Reduced Eligibility Code.', this);
                callback(true);
                return false;
            }
            this.setState({
                conformationModalIsOpen: true,
                pendingUpdateType: 'studentUpdate',
                pendingUpdateData: { callback }
            });
            return false;
        }

        // If no downgrade or adverseActionProcedure is disabled, proceed with normal update
        this.performStudentUpdate(callback);
    }

    performStudentUpdate(callback) {
        let allowed = [
            'firstName',
            'lastName',
            'studentId',
            'gradeName',
            'teacherName',
            "schoolYear",
            'parentuser',
            'mobileNo',
            'spendingLimit',
            'isReducePriceEligible',
            'isFreeMealEligible',
            'numberStreetApt',
            'cityStateZip',
            'hasMilkCard',
            'beforeCare',
            'isEnrollBCAndACPkt',
            'defaultNotifyEmail',
            "decisionReason",
            "category",
            "additionalNotes",
            "actualPrg",
            "freezePreOrder"
        ];
        let filtered = Object.keys(this.state.editStudent)
            .filter(key => allowed.includes(key))
            .reduce((obj, key) => {
                obj[key] = this.state.editStudent[key];
                obj["loggedUser"] = sessionStorage.getItem('loggedUserName');
                return obj;
            }, {});
        filtered.mobileNo = (filtered.mobileNo.trim().length > 0 ? ((dial_code() + filtered.mobileNo.substr(-this.state.mobileLength))) : '');
        let recId = this.state.editStudent._links.self.href.split("/").pop();
        let headers = {
            "Content-Type": "application/json"
        };

        postWithHeadersResponse('/studentUpdate?studentRecId=' + recId + '&access_token=', JSON.stringify(filtered), headers).then(response => {
            console.log('response', response)
            if (response.statusCode == 200) {
                // alert('student data updated')
                _addNotification('Successfully updated student data.', this);
                callback(true);
                this.closeModal("editModalIsOpen");
                this.setState({
                    conformationModalIsOpen: false,
                    pendingUpdateType: null,
                    pendingUpdateData: null
                });
            }
            else {
                throw Error(response.statusMessage);
            }
        }).catch(error => {
            // this.closeModal("editModalIsOpen");
            console.log('Error while updating', error)
            _addNotificationError(error.message, this);
            callback(true);
        });
    }

    cancelPendingUpdate = () => {
        const pendingCallback = this.state.pendingUpdateData && this.state.pendingUpdateData.callback;
        if (typeof pendingCallback === 'function') {
            pendingCallback();
        }
        this.setState({
            conformationModalIsOpen: false,
            pendingUpdateType: null,
            pendingUpdateData: null
        });
    }

    getFilteredData = (grade, filter) => {

        let filteredData = [];
        switch (filter) {
            case 'invited':
                this.state.students.map(item => {
                    item.register ? filteredData.push(item) : '';
                });

                this.setState({ data: filteredData });
                console.log('invited', JSON.stringify(filteredData, null, 2));
                break;
            case 'notInvited':
                this.state.students.map(item => {
                    !item.register ? filteredData.push(item) : '';
                });

                this.setState({ data: filteredData });
                console.log('not invited', JSON.stringify(filteredData, null, 2));
                break;
            case 'registered':
                this.state.students.map(item => {
                    item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'notRegistered':
                this.state.students.map(item => {
                    !item.parentuser.isParentRegistered ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('not registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'enrollBC&AC':
                this.state.students.map(item => {
                    item.isEnrollBCAndACPkt ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                console.log('not registered', JSON.stringify(filteredData, null, 2));
                break;
            case 'Free':
                this.state.students.map(item => {
                    item.isFreeMealEligible ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'Reduced':
                this.state.students.map(item => {
                    item.isReducePriceEligible ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'Regular':
                this.state.students.map(item => {
                    (!item.isFreeMealEligible && !item.isReducePriceEligible) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'BC':
                this.state.students.map(item => {
                    (item.beforeCare === true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
            case 'AC':
                this.state.students.map(item => {
                    (item.beforeCare !== true) ? filteredData.push(item) : '';
                });
                this.setState({ data: filteredData });
                break;
        }
    };
    toggleSelection = (key, shift, row) => {
        //alert('selection')
        // alert(key)
        let selection = [...this.state.selection];
        let selectionStuList = this.state.selectionStuList
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            delete selectionStuList[key];
        } else {
            // it does not exist so add it
            selection.push(key);
            selectionStuList[key] = { name: row.firstName + ' ' + row.lastName, id: row._links.self.href.split("/").pop() }
        }
        // update the state
        this.setState({ selectAll: false, selection: selection, selectionStuList: selectionStuList });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectionStuList = {}
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectionStuList[item._original._id] = { name: item._original.firstName + ' ' + item._original.lastName, id: item._original._links.self.href.split("/").pop() }
            });
        }
        this.setState({ selectAll, selection, selectionStuList });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };
    logSelection = () => {
        console.log("selection:", this.state.selection);
    };
    buildDataFormatForExport = () => {
        // console.log("DATA", this.props.data)
        return (
            [{
                columns: [{ title: 'NAME' }, { title: 'GRADE' }, { title: 'ALLERGIES' },
                { title: 'MOBILE' }, { title: 'STUDENT ID' }, { title: 'PARENT' }
                    , { title: 'HAS MILK CARD' }, { title: 'REDUCED PRICE ELIGIBLE' }, { title: 'FREE MEAL ELIGIBLE' },
                { title: 'ENROLL BC&AC PACK' }, { title: 'BC/AC' }],
                data: this.state.data.map(item => {
                    return [{ value: item.fullName || '' }, { value: item.gradeName || '' }, { value: item.allergies || '' }
                        , { value: item.mobileNo || '' }, { value: item.studentId || '' }, { value: item.parentuser.userName || '' }
                        , { value: item.hasMilkCard || '' }, { value: item.isReducePriceEligible || '' }, { value: item.isFreeMealEligible || '' }
                        , { value: item.isEnrollBCAndACPkt || '' }, { value: item.beforeCare ? 'BC' : 'AC' }]
                })
            }]
        )
    }
    generatePinByGrade() {
        let schoolId = sessionStorage.getItem('SchoolId');
        let grade = this.state.tabIndex;
        put(`/${schoolId}/generateStudentsPIN?grade=${grade}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification('Successfully Generated Pin.', this);
            this.setState({ loading: false });
            this.getDataByGrade(grade);
        }).catch(
            (error) => {
                _addNotificationError('Unable to Generate Pin ! Try Again.', this);
                console.log('Generate Pin data response', error)
            }
        );
    }
    bar_qr_code = (type, callback) => {
        let schoolId = sessionStorage.getItem('SchoolId');
        let headers = {
            'Content-Type': 'application/json',
            // responseType: "blob"
        };
        let data = [];

        if (this.state.selectAll && this.state.tabIndex === 0 && this.state.studentCount === (this.state.selection).length) {
            data = ['ALL'];
        }
        else {
            let selectedRows = this.state.selection;
            if (selectedRows.length !== 0) {
                data = selectedRows;
            } else {
                _addNotificationError('Please select atleast one student.', this);
                this.setState({ loading: false });
                callback(true);
                return false;
            }
        }
        if (type == 'BAR') {
            const url = `/qrcode/generateBarCodePdf?schoolYear=${sessionStorage.getItem('schoolYearValue')}&schoolId=${schoolId}&access_token=`
            postWithHeaders(url, JSON.stringify(data), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.blob();
            }).then((response) => {
                let filename = `barcodes`;
                showFile(response, filename);
                callback(true);
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError('Failed to download file ! Try again.', this);
                    callback(true);
                    console.log('Send Notification Error', error)
                }
            );
        }
        if (type == 'QR') {
            const _url = `/qrcode/generateQRCodePdf?schoolYear=${sessionStorage.getItem('schoolYearValue')}&schoolId=${schoolId}&access_token=`
            postWithHeaders(_url, JSON.stringify(data), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.blob();

            }).then((response) => {
                let filename = `qrcodes`;
                showFile(response, filename);
                callback(true);
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError('Failed to download file ! Try again.', this);
                    callback(true);
                    console.log('Send Notification Error', error)
                }
            );
        }
        return false;
    }
    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected } = this;
        const { data, selectAll } = this.state;

        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };

        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }

        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 style={{ marginBottom: '5px' }}><span>Manage Students Info for: {sessionStorage.getItem('schoolYear')}</span></h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                                    {/* Filters take the free space and wrap internally, so the action
                                        buttons on the right keep their place instead of being pushed
                                        onto a second line. */}
                                    <div id="selector" className="btn-group" style={{ margin: '5px', display: 'flex', flexWrap: 'wrap', rowGap: 4, flex: '1 1 auto', minWidth: 0 }}>
                                        <button type="button"
                                            className="btn btn-xs btn-inactive-color active"
                                            id="Ordered"
                                            style={{
                                                margin: 0,
                                                marginLeft: 2,
                                                fontSize: 11
                                            }}
                                            onClick={() => {
                                                this.getDataByGrade(this.state.tabIndex);
                                                this.setState({
                                                    selectAll: false,
                                                    selection: [],
                                                    selectionStuList: {}
                                                    // gradeName: this.state.tabIndex
                                                })
                                            }}
                                        >All
                                        </button>
                                        {getAccessLevelByModule(modEnum.PR) ?
                                            <Fragment><button type="button"
                                                className="btn btn-xs btn-inactive-color"
                                                id="Ordered"
                                                name="invited"
                                                style={{
                                                    margin: 0,
                                                    marginLeft: 2,
                                                    fontSize: 11
                                                }}
                                                onClick={() => {
                                                    // this.getFilteredData(this.state.tabIndex, 'invited');
                                                    this.filterSchool();
                                                    this.setState({
                                                        selectAll: false,
                                                        selection: [],
                                                        selectionStuList: {}
                                                    })
                                                }}
                                            >Invited
                                            </button>
                                                <button type="button"
                                                    className="btn btn-xs btn-inactive-color"
                                                    name="notInvited"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 2,
                                                        fontSize: 11
                                                    }} id="NotOrdered"
                                                    onClick={() => {
                                                        // this.getFilteredData(this.state.tabIndex, 'notInvited');
                                                        this.filterSchool();
                                                        this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                    }}
                                                >Not Invited
                                                </button>
                                                <button type="button"
                                                    className="btn btn-xs btn-inactive-color"
                                                    name="registered"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 2,
                                                        fontSize: 11
                                                    }} id="NotPaid"
                                                    onClick={() => {
                                                        //this.getFilteredData(this.state.tabIndex, 'registered');
                                                        this.filterSchool();
                                                        this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                    }}
                                                > Registered
                                                </button>
                                                <button type="button"
                                                    className="btn btn-xs btn-inactive-color"
                                                    name="notRegistered"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 2,
                                                        fontSize: 11
                                                    }} id="NotPaid"
                                                    onClick={() => {
                                                        //this.getFilteredData(this.state.tabIndex, 'notRegistered');
                                                        this.filterSchool();
                                                        this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                    }}
                                                > Not Registered
                                                </button>
                                            </Fragment> : null
                                        }
                                        {getAccessLevelByModule(modEnum.BACM) ?
                                            <button type="button" className="btn btn-xs btn-inactive-color" name="enrollBC&AC"
                                                style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="enrollBC&AC" onClick={
                                                    () => {
                                                        this.filterSchool();
                                                        this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                    }}>Enroll B & A.C</button> : null
                                        }
                                        {
                                            getAccessLevelByModule(modEnum.LETM) ?
                                                <Fragment>
                                                    <button type="button" className="btn btn-xs btn-inactive-color" name="Free"
                                                        style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="Free" onClick={
                                                            () => {
                                                                this.filterSchool();
                                                                this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                            }}>Free</button>
                                                    <button type="button" className="btn btn-xs btn-inactive-color" name="Reduced"
                                                        style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="Reduced" onClick={
                                                            () => {
                                                                this.filterSchool();
                                                                this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                            }}>Reduced</button>
                                                    <button type="button" className="btn btn-xs btn-inactive-color" name="Regular"
                                                        style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="Regular" onClick={
                                                            () => {
                                                                this.filterSchool();
                                                                this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                            }}>Regular</button>
                                                </Fragment> : null
                                        }
                                        {
                                            getAccessLevelByModule(modEnum.BACM) ?
                                                <Fragment><button type="button" className="btn btn-xs btn-inactive-color" name="BC"
                                                    style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="BC" onClick={
                                                        () => {
                                                            this.filterSchool();
                                                            this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                        }}>Before Care</button>
                                                    <button type="button" className="btn btn-xs btn-inactive-color" name="AC"
                                                        style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="AC" onClick={
                                                            () => {
                                                                this.filterSchool();
                                                                this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                            }}>After Care</button></Fragment> : null
                                        }

                                        <button type="button" className="btn btn-xs btn-inactive-color" name="btnNewStudents"
                                            style={{ margin: 0, marginLeft: 2, fontSize: 11 }} id="btnNewStudents" onClick={
                                                () => {
                                                    this.filterSchool();
                                                    this.setState({ selectAll: false, selection: [], selectionStuList: {} })
                                                }}>New Students</button>

                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start', flexShrink: 0, marginLeft: 'auto' }}>
                                        <CustomSubmit id="updateNotifyPreference" type="button" className="btn btn-xs btn-primary"
                                            style={{
                                                margin: 0,
                                                marginLeft: 3,
                                                fontSize: 11,
                                            }}
                                            handleSubmit={(e, callback) => this.onUpdateNotifyPreference('updateNotifyPreference', callback)}
                                        >
                                            Update Notification Preference</CustomSubmit>
                                        <CustomSubmit id="updateTeacher" type="button" className="btn btn-xs btn-primary"
                                            style={{
                                                margin: 0,
                                                marginLeft: 3,
                                                fontSize: 11,
                                            }}
                                            handleSubmit={(e, callback) => this.onUpdateTeachers('updateTeacher', callback)}
                                        >
                                            Update Teacher</CustomSubmit>
                                    </div>


                                </div>

                            </div>
                        </div>

                        <div className="row">
                            <Modal isOpen={this.state.teacherObj.openTeacherModal} style={deleteStyles} contentLabel="Activation">
                                <form name="teacherModal">
                                    <div className='row' style={{ marginBottom: '15px' }}>
                                        <div className='col-md-12'>
                                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Update Teacher</span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <label htmlFor={`txtTeacherName`}>Teacher Name*</label>
                                            <input id={`txtTeacherName`}
                                                type="text" className="form-control"
                                                placeholder={''}
                                                value={this.state.teacherObj.teacherName} style={{ marginRight: '20px' }}
                                                onChange={(e) => {
                                                    const { teacherObj } = this.state;
                                                    teacherObj.teacherName = e.target.value;
                                                    this.setState({ teacherObj });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: '10px' }}>
                                        <div className='col-md-12'>
                                            <div className="text-right">
                                                <button type="button" className="btn btn-sm btn-primary btn-lg"
                                                    onClick={() => {
                                                        const { teacherObj } = this.state;
                                                        teacherObj.openTeacherModal = false;
                                                        teacherObj.teacherName = "";
                                                        this.setState({ teacherObj });
                                                    }}
                                                    style={{ margin: 0, fontSize: 14, }}> Cancel
                                                </button>
                                                <CustomSubmit id="teacherSubmit" type="button" className="btn  btn-sm btn-success btn-lg"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 5,
                                                        fontSize: 14,
                                                    }}
                                                    handleSubmit={(e, callback) => this.onUpdateTeachers('teacherSubmit', callback)}
                                                >
                                                    Submit</CustomSubmit>

                                            </div>
                                        </div>

                                    </div>

                                </form>

                            </Modal>
                            <Modal isOpen={this.state.notifyPrefObj.openNotifyPrefModal} style={deleteStyles} contentLabel="Activation">
                                <form name="notifyPrefModal">
                                    <div className='row' style={{ marginBottom: '15px' }}>
                                        <div className='col-md-12'>
                                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Update Notification Preference</span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <span>{`${Object.keys(this.state.selectionStuList || {}).length} student(s) selected.`}</span>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: '10px' }}>
                                        <div className='col-md-12'>
                                            <label htmlFor={`ddlNotifyPref`}>Email preference*</label>
                                            <select id={`ddlNotifyPref`} className="form-control"
                                                value={this.state.notifyPrefObj.defaultNotifyEmail}
                                                style={{ marginRight: '20px' }}
                                                onChange={(e) => {
                                                    const { notifyPrefObj } = this.state;
                                                    notifyPrefObj.defaultNotifyEmail = e.target.value;
                                                    this.setState({ notifyPrefObj });
                                                }}
                                            >
                                                <option value={parentEmailsEnum.primary}>{parentEmailsEnum.primary}</option>
                                                <option value={parentEmailsEnum.alternate}>{parentEmailsEnum.alternate}</option>
                                                <option value={parentEmailsEnum.both}>{parentEmailsEnum.both}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='row' style={{ marginTop: '10px' }}>
                                        <div className='col-md-12'>
                                            <div className="text-right">
                                                <button type="button" className="btn btn-sm btn-primary btn-lg"
                                                    onClick={() => {
                                                        const { notifyPrefObj } = this.state;
                                                        notifyPrefObj.openNotifyPrefModal = false;
                                                        notifyPrefObj.defaultNotifyEmail = parentEmailsEnum.both;
                                                        this.setState({ notifyPrefObj });
                                                    }}
                                                    style={{ margin: 0, fontSize: 14, }}> Cancel
                                                </button>
                                                <CustomSubmit id="notifyPrefSubmit" type="button" className="btn  btn-sm btn-success btn-lg"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 5,
                                                        fontSize: 14,
                                                    }}
                                                    handleSubmit={(e, callback) => this.onUpdateNotifyPreference('notifyPrefSubmit', callback)}
                                                >
                                                    Submit</CustomSubmit>

                                            </div>
                                        </div>

                                    </div>

                                </form>

                            </Modal>
                            <Modal
                                isOpen={this.state.addModalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                style={customStyles}
                                contentLabel="Activation"
                            >
                                <form name="addStudents" className="" >
                                    <div className="row">
                                        <div className="col-xs-11 col-xs-offset-1">
                                            {
                                                this.state.studentsForm.map((student, idx) => {
                                                    return (
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} First Name`}>First Name*</label>
                                                                        <input id={`Student #${idx + 1} First Name`}
                                                                            type="text" className="form-control"
                                                                            placeholder={`Student #${idx + 1} First Name`}
                                                                            value={student.firstName} style={{ marginRight: '20px' }}
                                                                            onChange={this.handleFirstNameChange(idx)}
                                                                            required />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} Last Name`}>Last Name*</label>
                                                                        <input type="text" className="form-control" id={`Student #${idx + 1} Last Name`}
                                                                            placeholder={`Student #${idx + 1} Last Name`}
                                                                            value={student.lastName} style={{ marginRight: '20px' }}
                                                                            onChange={this.handleLastNameChange(idx)}
                                                                            required />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} StudentId`}>Student Id*</label>
                                                                        <input
                                                                            type="text" className="form-control" id={`Student #${idx + 1} StudentId`}
                                                                            placeholder={`Student #${idx + 1} StudentId`}
                                                                            value={student.studentId} style={{ marginRight: '20px' }}
                                                                            onChange={this.handleIdChange(idx)}
                                                                            required />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} Grade`}>Grade*</label>
                                                                        <select id={`Student #${idx + 1} Grade`}
                                                                            className="form-control"
                                                                            style={{ marginRight: '20px' }}
                                                                            onChange={this.handleGradeChange(idx)}
                                                                            required>
                                                                            <option disabled selected value=''>Grade</option>
                                                                            {getSchoolGrades(0, false).map((item) => {
                                                                                return <option
                                                                                    value={item.value}>{item.label}</option>
                                                                            }, this)}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} parentEmail`}>Parent Email*</label>
                                                                        <input
                                                                            name="parentEmailId" id={`Student #${idx + 1} parentEmail`}
                                                                            type={student.parentuser.userName == 'NA' ? "text" : "email"}
                                                                            pattern={student.parentuser.userName == 'NA' ? null : "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"}  // This also works ^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$
                                                                            className="form-control"
                                                                            placeholder={`Parent #${idx + 1} Mail Id /NA`}
                                                                            value={student.parentuser.userName}
                                                                            onChange={this.handleMailChange(idx)}
                                                                            required />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} altEmail`}>Alt. Email</label>
                                                                        <input
                                                                            name="altParentEmailId"
                                                                            id={`Student #${idx + 1} altEmail`}
                                                                            type="email"
                                                                            pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                            className="form-control"
                                                                            placeholder={`Parent #${idx + 1} Alternate Mail Id (Optional)`}
                                                                            value={student.parentuser.altParentEmailId}
                                                                            onChange={this.handleAltMailChange(idx)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} mobileNoAdd`}>Mobile</label>
                                                                        <input type="text"
                                                                            className="form-control"
                                                                            id="mobileNoAdd"
                                                                            placeholder={'Mobile Number'}
                                                                            onChange={this.handleMobileNoChange(idx)}
                                                                            maxLength={this.state.mobileLength}
                                                                            onKeyPress={numberOnly} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3 ">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} teacherNameAdd`}>Teacher</label>
                                                                        <input
                                                                            className="form-control"
                                                                            list="teachers"
                                                                            id="teacherNameAdd"
                                                                            placeholder="Teacher Name" autoComplete="off"
                                                                            style={{ marginRight: '20px' }}
                                                                            onChange={this.handleTeacherChange(idx)}
                                                                            required />
                                                                        <datalist id="teachers">
                                                                            {teacherNames.map(function (key) {
                                                                                return <option
                                                                                    value={key}>{key}</option>
                                                                            }, this)}
                                                                        </datalist>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} Street`}>Street, Apt.</label>
                                                                        <input type="text" className="form-control" id={`Student #${idx + 1} Street`}
                                                                            placeholder={`Student #${idx + 1}- Street, Apt`}
                                                                            value={student.numberStreetApt} style={{ marginRight: '20px' }}
                                                                            onChange={this.handleAddressChange(idx)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3 ">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} city`}>City, State, Zip.</label>
                                                                        <input type="text" className="form-control" id={`Student #${idx + 1} city`}
                                                                            placeholder={`Student #${idx + 1}- City, State, Zip`}
                                                                            value={student.cityStateZip} style={{ marginRight: '20px' }}
                                                                            onChange={this.handleZipChange(idx)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} defEmail`}>Email notification preference</label>
                                                                        <select className="form-control" id={`Student #${idx + 1} defEmail`}
                                                                            value={student.defaultNotifyEmail}
                                                                            style={{ marginRight: '20px' }}
                                                                            onChange={this.handleDefaultEmailNotifyChange(idx)}
                                                                            required>
                                                                            <option value={parentEmailsEnum.primary}>{parentEmailsEnum.primary}</option>
                                                                            <option value={parentEmailsEnum.alternate}>{parentEmailsEnum.alternate}</option>
                                                                            <option value={parentEmailsEnum.both}>{parentEmailsEnum.both}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                {this.state.sLimitStatus === "true" && <div className="col-xs-2">
                                                                    <div className="form-group">
                                                                        <label htmlFor={`Student #${idx + 1} sLimit`}>Spending Limit</label>
                                                                        <div className="input-group">
                                                                            <span className="input-group-addon" id="basic-addon1">{currency_symbol(this.state.mealSchoolId)}</span>
                                                                            <input type="text" id={`Student #${idx + 1} sLimit`} style={{ marginRight: '20px' }} className="form-control" onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                onChange={this.handleSpendingLimit(idx)} name="amount" value={student.spendingLimit} placeholder="Amount" />
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {/* {this.state.studentsForm.length === idx + 1 ?
                                                                    <div className="col-xs-1">
                                                                        <i className="fa fa-plus fa-2x"
                                                                            onClick={this.handleAddStudent}
                                                                            style={{
                                                                                width: '30px',
                                                                                padding:'10px',
                                                                                cursor: 'pointer',
                                                                                color: '#56bff7'
                                                                            }}
                                                                        />
                                                                    {this.state.studentsForm.length>1? 
                                                                    <i className="fa fa-close fa-2x"
                                                                            onClick={this.handleRemoveStudent(idx)}
                                                                            style={{
                                                                                width: '30px',
                                                                                padding:'10px',
                                                                                cursor: 'pointer',
                                                                                color: '#f45f3a'
                                                                            }}
                                                                        />:null} 
                                                                    </div> :
                                                                    <div className="col-xs-1">
                                                                        <i className="fa fa-close fa-2x"
                                                                            onClick={this.handleRemoveStudent(idx)}
                                                                            style={{
                                                                                width: '30px',
                                                                                padding:'10px',
                                                                                cursor: 'pointer',
                                                                                color: '#f45f3a'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                } */}
                                                            </div>
                                                            <div className="row top-buffer">
                                                                {
                                                                    getAccessLevelByModule(modEnum.MCS) || getAccessLevelByModule(modEnum.BACM) ? <div className="col-xs-4">
                                                                        <div className="form-group">
                                                                            {getAccessLevelByModule(modEnum.MCS) ?
                                                                                <span style={{ margin: 10 }}><input style={eligibleCheck}
                                                                                    type="checkbox"
                                                                                    name="hasMilkCard"
                                                                                    id={"hasMilkCard" + idx}
                                                                                    data-index={idx}
                                                                                    className="chb"
                                                                                    onChange={(e) => {
                                                                                        let idx = e.target.getAttribute('data-index')
                                                                                        this.handleCardCheckboxChange(e, idx)
                                                                                    }} />Has Milk Card</span> : null
                                                                            }
                                                                            {getAccessLevelByModule(modEnum.BACM) ?
                                                                                <span className="" style={{ margin: 10 }}><input
                                                                                    style={eligibleCheck} type="checkbox"
                                                                                    name="beforeCare"
                                                                                    id={"beforeCare" + idx}
                                                                                    data-index={idx}
                                                                                    className="chb" onChange={(e) => {
                                                                                        let idx = e.target.getAttribute('data-index')
                                                                                        this.handleCardCheckboxChange(e, idx)
                                                                                    }} />Is Before care</span> : null
                                                                            }
                                                                        </div>
                                                                    </div> : null
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                {
                                                                    getAccessLevelByModule(modEnum.LETM) ?
                                                                        <Fragment>
                                                                            <div className="col-xs-3 text-left">
                                                                                <label style={{ marginRight: 5 }}>Eligible for: </label><br />

                                                                                <span style={{ margin: 10 }}><input style={eligibleCheck}
                                                                                    type="checkbox"
                                                                                    name="isReducePriceEligible"
                                                                                    id={"isReducePriceEligible" + idx}
                                                                                    class="chb"
                                                                                    onChange={this.handleReducePriceChange(idx)} />Reduced Price</span>

                                                                                <span className="" style={{ margin: 10 }}><input
                                                                                    style={eligibleCheck} type="checkbox"
                                                                                    name="isFreeMealEligible"
                                                                                    id={"isFreeMealEligible" + idx}
                                                                                    class="chb" onChange={this.handleFreeMealChange(idx)} />Free Lunch</span>
                                                                            </div>
                                                                            {
                                                                                (student.isReducePriceEligible == true || student.isFreeMealEligible == true) ?
                                                                                    <Fragment>
                                                                                        <div className="col-xs-4">
                                                                                            <div className="form-group">
                                                                                                <label htmlFor={`Student #${idx + 1}-EligibilityCodes`}>Eligibility Codes:</label>
                                                                                                <select className="form-control" id={`Student #${idx + 1} -EligibilityCodes`}
                                                                                                    value={student.decisionReason}
                                                                                                    style={{ marginRight: '20px' }}
                                                                                                    onChange={(evt) => {
                                                                                                        const newStudent = this.state.studentsForm.map((student, sidx) => {
                                                                                                            if ((idx || 0) !== sidx) return student;
                                                                                                            var obj = { ...student };
                                                                                                            obj.decisionReason = evt.target.value;
                                                                                                            obj.category = ((evt.target.selectedOptions[0] || {}).text || '');
                                                                                                            return obj;
                                                                                                        });
                                                                                                        this.setState({ studentsForm: newStudent });
                                                                                                    }} required>
                                                                                                    <option></option>
                                                                                                    {
                                                                                                        (this.state.eligibilityCodes || []).filter(code => {
                                                                                                            if (student.isReducePriceEligible) {
                                                                                                                return code.redElig === true

                                                                                                            } else if (student.isFreeMealEligible) {
                                                                                                                return code.freeElig === true
                                                                                                            } else {
                                                                                                                return false
                                                                                                            }
                                                                                                        }).map((code, i) => {
                                                                                                            return <option value={code.code}>{code.codeDesc}</option>

                                                                                                        })
                                                                                                    }
                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            student.isFreeMealEligible == true && student.category === 'Free (TANF,SNAP,Foster)' ?
                                                                                                <div className="col-xs-2">
                                                                                                    <div className="form-group">
                                                                                                        <label htmlFor={`Student #${idx + 1}-actualPrg`}>Specific Program:</label>
                                                                                                        <select className="form-control" id={`Student #${idx + 1}-actualPrg`}
                                                                                                            value={student.actualPrg}
                                                                                                            style={{ marginRight: '20px' }}
                                                                                                            onChange={(evt) => {
                                                                                                                const newStudent = this.state.studentsForm.map((student, sidx) => {
                                                                                                                    if ((idx || 0) !== sidx) return student;
                                                                                                                    var obj = { ...student };
                                                                                                                    obj.actualPrg = evt.target.value;
                                                                                                                    return obj;
                                                                                                                });
                                                                                                                this.setState({ studentsForm: newStudent });
                                                                                                            }} required>
                                                                                                            <option></option>
                                                                                                            <option>TANF</option>
                                                                                                            <option>SNAP</option>
                                                                                                            <option>Foster</option>

                                                                                                        </select>
                                                                                                    </div>
                                                                                                </div> :
                                                                                                student.isFreeMealEligible == true && student.category === 'First Nation' ? <div className="col-xs-2">
                                                                                                    <div className="form-group">
                                                                                                        <label htmlFor={`Student #${idx + 1}-actualPrg`}>Specific Program:</label>
                                                                                                        <select className="form-control" id={`Student #${idx + 1}-actualPrg`}
                                                                                                            value={student.actualPrg}
                                                                                                            style={{ marginRight: '20px' }}
                                                                                                            onChange={(evt) => {
                                                                                                                const newStudent = this.state.studentsForm.map((student, sidx) => {
                                                                                                                    if ((idx || 0) !== sidx) return student;
                                                                                                                    var obj = { ...student };
                                                                                                                    obj.actualPrg = evt.target.value;
                                                                                                                    return obj;
                                                                                                                });
                                                                                                                this.setState({ studentsForm: newStudent });
                                                                                                            }} required>
                                                                                                            <option></option>
                                                                                                            {
                                                                                                                FreeNationOptions.map((item) => {
                                                                                                                    return <option value={item}>{item}</option>
                                                                                                                })
                                                                                                            }
                                                                                                        </select>
                                                                                                    </div>
                                                                                                </div>
                                                                                                    : null
                                                                                        }
                                                                                    </Fragment> : null
                                                                            }
                                                                        </Fragment>
                                                                        : null
                                                                }

                                                            </div>
                                                            <div className="row">
                                                                <div className="col-xs-10">
                                                                    <div className="form-group">
                                                                        <label htmlFor={"additionalNotes" + idx}>Additional Notes</label>
                                                                        <textarea id={"additionalNotes" + idx} className="form-control"
                                                                            value={student.additionalNotes} onChange={(e) => {
                                                                                const newStudent = this.state.studentsForm.map((student, sidx) => {
                                                                                    if ((idx || 0) !== sidx) return student;
                                                                                    var obj = { ...student };
                                                                                    obj.additionalNotes = e.target.value;
                                                                                    return obj;
                                                                                });
                                                                                this.setState({ studentsForm: newStudent });
                                                                            }}></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <hr style={{ margin: '5px 0px' }} />

                                                        </div>)
                                                })}
                                            <div className="text-right add-student-footer">
                                                <button type="button" id="cancelAdd" className="btn btn-primary btn-lg"
                                                    onClick={() => this.closeModal('addModalIsOpen')}
                                                    style={{ margin: 0, fontSize: 14, }}><i
                                                        className="glyphicon glyphicon-remove"
                                                        style={{ marginRight: 0, paddingLeft: 0 }}></i> Cancel
                                                </button>
                                                <CustomSubmit id="addStudent" type="button" className="btn btn-success btn-lg"
                                                    style={{
                                                        margin: 0,
                                                        marginLeft: 5,
                                                        fontSize: 14,
                                                    }}
                                                    handleSubmit={(e, callback) => this.onStudentDataSubmit(e, callback)}
                                                >
                                                    <i className="glyphicon glyphicon-ok"></i> Add Student</CustomSubmit>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </Modal>
                            <Modal
                                isOpen={this.state.editModalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                style={customStyles}
                                contentLabel="Activation"
                            >
                                <div className="row">
                                    <div className="col-xs-2 col-sm-2 col-md-2">
                                        <div className="form-group">
                                            <div className="media courseList">
                                                <a className="media-left" style={{ width: '150px', height: '150px', margin: '15px' }}>
                                                    <img className="media-object" style={{ width: '150px', height: '150px' }}
                                                        src={this.state.editStudent.image}
                                                        alt="Student image" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-10 col-sm-10 col-md-10">
                                        <form name="editStudents" className="" >
                                            <div className="form-group">
                                                <div className="row top-buffer">
                                                    <div className="col-xs-3 col-xs-offset-1">
                                                        <div className="form-group">
                                                            <label htmlFor={`First Name`}>First Name*</label>
                                                            <input id={`First Name`}
                                                                type="text" className="form-control" name="firstName"
                                                                placeholder={`Student First Name`}
                                                                value={this.state.editStudent.firstName}
                                                                style={{ marginRight: '20px' }}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                                required />
                                                        </div>
                                                    </div>

                                                    <div className="col-xs-3">
                                                        <div className="form-group">
                                                            <label htmlFor={`Last Name`}>Last Name*</label>
                                                            <input id={'Last Name'}
                                                                type="text" className="form-control" name="lastName"
                                                                placeholder={`Student Last Name`}
                                                                value={this.state.editStudent.lastName}
                                                                style={{ marginRight: '20px' }}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <div className="form-group">
                                                            <label htmlFor={`studentId`}>Student Id*</label>
                                                            <input id={`studentId`}
                                                                type="text" className="form-control" name="studentId"
                                                                placeholder={`Student ID`}
                                                                value={this.state.editStudent.studentId}
                                                                style={{ marginRight: '20px' }}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                                required disabled />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <div className="form-group">
                                                            <label htmlFor={`grade`}>Grade*</label>
                                                            <select id={`grade`}
                                                                className="form-control"
                                                                value={this.state.editStudent.gradeName}
                                                                style={{ marginRight: '20px' }}
                                                                name="gradeName"
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                                required>
                                                                <option disabled selected value>Grade</option>
                                                                {getSchoolGrades(0, false).map((item) => {
                                                                    return <option
                                                                        value={item.value}>{item.label}</option>
                                                                }, this)}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-3 col-xs-offset-1">
                                                        <div className="form-group">
                                                            <label htmlFor={`parentEmail`}>Parent Email*</label>
                                                            <input id="parentEmail"
                                                                type={this.state.editStudent.parentuser.userName == 'NA' ? "text" : "email"}
                                                                pattern={this.state.editStudent.parentuser.userName == 'NA' ? null : "[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"}
                                                                className="form-control"
                                                                name="parentEmailId"
                                                                placeholder={`Parent E-mail Id`}
                                                                value={this.state.editStudent.parentuser.userName}
                                                                onChange={e => this.handleEmailChangeEditStudent(e)}
                                                                required />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-3">
                                                        <div className="form-group">
                                                            <label htmlFor={`altEmail`}>Alt. Email</label>
                                                            <input id="altEmail"
                                                                type="email"
                                                                pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                                                                className="form-control"
                                                                name="parentAltEmail"
                                                                placeholder={`Parent Alternate E-Mail Id(Optional)`}
                                                                value={this.state.editStudent.parentuser.parentAltEmail}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                            />
                                                        </div></div>
                                                    <div className="col-xs-2">
                                                        <div className="form-group">
                                                            <label htmlFor={`mobileNoEdit`}>Mobile</label>
                                                            <input type="text"
                                                                className="form-control"
                                                                id="mobileNoEdit"
                                                                placeholder={'Mobile Number'}
                                                                value={this.state.editStudent.mobileNo}
                                                                onChange={value => this.handleEditMobileNo(value)}
                                                                maxLength={this.state.mobileLength}
                                                                onKeyPress={numberOnly} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-2">
                                                        <div className="form-group">
                                                            <label htmlFor={`teacherNameEdit`}>Teacher</label>

                                                            <input
                                                                className="form-control"
                                                                list='teachers'
                                                                id='teacherNameEdit'
                                                                value={this.state.editStudent.teacherName}
                                                                onFocus={this.handleTeachersEdit}
                                                                style={{ marginRight: '20px' }}
                                                                name="teacherName"
                                                                placeholder='Teacher Name' autoComplete='off'
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                                required />
                                                            <dataList id="teachers">
                                                                {teacherNames.map(function (key) {
                                                                    return <option
                                                                        value={key}>{key}</option>
                                                                }, this)}
                                                            </dataList>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-3 col-xs-offset-1">
                                                        <div className="form-group">
                                                            <label htmlFor={`numberStreetApt`}>Street, Apt.</label>
                                                            <input type="text" className="form-control"
                                                                placeholder={`Student- Street, Apt`}
                                                                name="numberStreetApt" id="numberStreetApt"
                                                                value={this.state.editStudent.numberStreetApt} style={{ marginRight: '20px' }}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-3 ">
                                                        <div className="form-group">
                                                            <label htmlFor={`altEmail`}>City, State, Zip.</label>
                                                            <input type="text" className="form-control"
                                                                placeholder={`Student- City, State, Zip`}
                                                                name="cityStateZip"
                                                                value={this.state.editStudent.cityStateZip} style={{ marginRight: '20px' }}
                                                                onChange={e => this.handleChangeEditStudent(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-3">
                                                        <div className="form-group">
                                                            <label htmlFor={`defNotify`}>Email notification preference</label>
                                                            <select className="form-control" id='defNotify' value={this.state.editStudent.defaultNotifyEmail}
                                                                style={{ marginRight: '20px' }}
                                                                onChange={(e) => this.handleDefaultEmailNotifyEditChange(e)}
                                                                required>
                                                                <option value={parentEmailsEnum.primary}>{parentEmailsEnum.primary}</option>
                                                                <option value={parentEmailsEnum.alternate}>{parentEmailsEnum.alternate}</option>
                                                                <option value={parentEmailsEnum.both}>{parentEmailsEnum.both}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {this.state.sLimitStatus === "true" && <div className="col-xs-2">
                                                        <div className="form-group">
                                                            <label htmlFor={`spendLimit`}>Spending Limit</label>
                                                            <div className="input-group">
                                                                <span className="input-group-addon" id="basic-addon1">{currency_symbol(this.state.mealSchoolId)}</span>
                                                                <input type="text" id='spendLimit' style={{ marginRight: '20px' }} value={this.state.editStudent.spendingLimit}
                                                                    onChange={(e) => this.handleEditSpendingLimit(e)} className="form-control" onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                    name="amount" placeholder="Amount" />
                                                            </div>
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="row">
                                                    {getAccessLevelByModule(modEnum.MCS) || getAccessLevelByModule(modEnum.BACM) ?
                                                        <div className="col-xs-4 col-xs-offset-1">
                                                            {getAccessLevelByModule(modEnum.MCS) ?
                                                                <span style={{ margin: 10 }}><input style={eligibleCheck}
                                                                    type="checkbox"
                                                                    name="hasMilkCard"
                                                                    id={"hasMilkCard"}
                                                                    className="chb"
                                                                    checked={this.state.editStudent.hasMilkCard ? true : false}
                                                                    onChange={(e, idx) => {
                                                                        this.handleCardCheckboxEditChange(e, idx)
                                                                    }} />Has Milk Card</span> : null
                                                            }
                                                            {
                                                                getAccessLevelByModule(modEnum.BACM) ?
                                                                    this.state.editStudent.isEnrollBCAndACPkt !== false ?
                                                                        <span className="" style={{ margin: 10 }}><input
                                                                            style={eligibleCheck} type="checkbox"
                                                                            name="beforeCare"
                                                                            id={"beforeCare"}
                                                                            checked={this.state.editStudent.beforeCare ? true : false}
                                                                            className="chb"
                                                                            onChange={(e, idx) => {
                                                                                this.handleCardCheckboxEditChange(e, idx)
                                                                            }} />Is Before care</span> : null
                                                                    : null
                                                            }
                                                        </div> : null
                                                    }
                                                </div>
                                                <div className="row">
                                                    {
                                                        getAccessLevelByModule(modEnum.LETM) ?
                                                            <Fragment>
                                                                <div className="col-xs-offset-1 col-xs-4 text-left">
                                                                    <label style={{ marginRight: 5 }}>Eligible for: </label><br />

                                                                    <span style={{ margin: 10 }}><input style={eligibleCheck}
                                                                        type="checkbox"
                                                                        name="isReducePriceEligible"
                                                                        id={"isReducePriceEligible"}
                                                                        className="chb"
                                                                        checked={this.state.editStudent.isReducePriceEligible}
                                                                        onChange={e => this.handleEditReducePrice(e)} />Reduced Price</span>

                                                                    <span className="" style={{ margin: 10 }}><input
                                                                        style={eligibleCheck} type="checkbox"
                                                                        name="isFreeMealEligible" id={"isFreeMealEligible"}
                                                                        className="chb"
                                                                        checked={this.state.editStudent.isFreeMealEligible}
                                                                        onChange={e => this.handleEditFreeMeal(e)} />Free Lunch</span>
                                                                </div>
                                                                {
                                                                    (this.state.editStudent.isReducePriceEligible == true || this.state.editStudent.isFreeMealEligible == true) ?
                                                                        <Fragment>
                                                                            <div className="col-xs-4">
                                                                                <div className="form-group">
                                                                                    <label htmlFor={`editEligibilityCodes`}>Eligibility Codes:</label>
                                                                                    <select className="form-control" id={`editEligibilityCodes`}
                                                                                        value={this.state.editStudent.decisionReason}
                                                                                        style={{ marginRight: '20px' }}
                                                                                        onChange={(evt) => {
                                                                                            const obj = { ...this.state.editStudent }
                                                                                            obj.decisionReason = evt.target.value;
                                                                                            obj.category = ((evt.target.selectedOptions[0] || {}).text || '');
                                                                                            this.setState({ editStudent: obj });
                                                                                        }} required>
                                                                                        <option></option>
                                                                                        {
                                                                                            (this.state.eligibilityCodes || []).filter(code => {
                                                                                                if (this.state.editStudent.isReducePriceEligible) {
                                                                                                    return code.redElig === true

                                                                                                } else if (this.state.editStudent.isFreeMealEligible) {
                                                                                                    return code.freeElig === true
                                                                                                } else {
                                                                                                    return false
                                                                                                }
                                                                                            }).map((code, i) => {
                                                                                                return <option value={code.code}>{code.codeDesc}</option>

                                                                                            })
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                this.state.editStudent.isFreeMealEligible == true && this.state.editStudent.category === 'Free (TANF,SNAP,Foster)' ?
                                                                                    <div className="col-xs-2">
                                                                                        <div className="form-group">
                                                                                            <label htmlFor={`editactualPrg`}>Specific Program:</label>
                                                                                            <select className="form-control" id={`editactualPrg`}
                                                                                                value={this.state.editStudent.actualPrg}
                                                                                                style={{ marginRight: '20px' }}
                                                                                                onChange={(evt) => {
                                                                                                    const obj = { ...this.state.editStudent }
                                                                                                    obj.actualPrg = evt.target.value;
                                                                                                    this.setState({ editStudent: obj });
                                                                                                }} required>
                                                                                                <option></option>
                                                                                                <option>TANF</option>
                                                                                                <option>SNAP</option>
                                                                                                <option>Foster</option>

                                                                                            </select>
                                                                                        </div>
                                                                                    </div> : this.state.editStudent.isFreeMealEligible == true && this.state.editStudent.category === 'First Nation' ? <div className="col-xs-2">
                                                                                        <div className="form-group">
                                                                                            <label htmlFor={`editactualPrg`}>Specific Program:</label>
                                                                                            <select className="form-control" id={`editactualPrg`}
                                                                                                value={this.state.editStudent.actualPrg}
                                                                                                style={{ marginRight: '20px' }}
                                                                                                onChange={(evt) => {
                                                                                                    const obj = { ...this.state.editStudent }
                                                                                                    obj.actualPrg = evt.target.value;
                                                                                                    this.setState({ editStudent: obj });
                                                                                                }}
                                                                                                required>
                                                                                                <option></option>
                                                                                                {
                                                                                                    FreeNationOptions.map((item) => {
                                                                                                        return <option value={item}>{item}</option>
                                                                                                    })
                                                                                                }
                                                                                            </select>
                                                                                        </div>
                                                                                    </div>
                                                                                        : null
                                                                            }
                                                                        </Fragment> : null
                                                                }
                                                            </Fragment>
                                                            : null}
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-offset-1 col-xs-10">
                                                        <span style={{ margin: 10 }}>
                                                            <input style={eligibleCheck}
                                                                type="checkbox"
                                                                name="editFreezePreOrder"
                                                                id={"editFreezePreOrder"}
                                                                checked={this.state.editStudent.freezePreOrder}
                                                                className="chb"
                                                                onChange={(e) => {
                                                                    const obj = { ...this.state.editStudent }
                                                                    obj.freezePreOrder = e.target.checked;
                                                                    this.setState({ editStudent: obj });
                                                                }} />Freeze Account for Pre-ordering</span>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-10 col-xs-offset-1">
                                                        <div className="form-group">
                                                            <label htmlFor={'editadditionalNotes'}>Additional Notes</label>
                                                            <textarea id="editadditionalNotes" className="form-control"
                                                                value={this.state.editStudent.additionalNotes} onChange={(e) => {
                                                                    const obj = { ...this.state.editStudent }
                                                                    obj.additionalNotes = e.target.value;
                                                                    this.setState({ editStudent: obj });
                                                                }}></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr style={{ margin: '5px 0px' }} />
                                                <div className="text-right add-student-footer">
                                                    <button type="button" className="btn btn-primary btn-sm"
                                                        onClick={() => this.closeModal('editModalIsOpen')}
                                                        style={{ margin: 0, fontSize: 14 }}><i
                                                            className="glyphicon glyphicon-remove"
                                                            style={{ marginRight: 0, paddingLeft: 0 }}></i> Cancel
                                                    </button>
                                                    <CustomSubmit id="updateSubmit" type="button" className="btn btn-success btn-sm"

                                                        handleSubmit={(e, callback) => this.onUpdateStudentSubmit(e, callback)}
                                                        style={{
                                                            margin: 0,
                                                            marginLeft: 5,
                                                            fontSize: 14,
                                                        }}>
                                                    <i className="glyphicon glyphicon-ok"></i> Update</CustomSubmit> 
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </Modal>
                            <Modal
                                isOpen={this.state.conformationModalIsOpen}
                                onRequestClose={this.cancelPendingUpdate}
                                style={modalStyles}
                                contentLabel="Confirmation">
                                <div className="modal-header">
                                    <h4 className="modal-title modal-title-color" id="conformationLabel">Confirmation</h4>
                                </div>
                                <div className="modal-body">
                                    <p>"This will notify the student's parent/guardian of this change. The student will continue to receive their original benefits for the next 10 operating days. If the parent/guardian files an appeal, update the status for the student under Claims Reports → Adverse Action"</p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-sm"
                                        onClick={this.cancelPendingUpdate}
                                        style={{ margin: 0, fontSize: 14 }}> Cancel
                                    </button>
                                    <button id="confirmEligibilityChange" type="button" className="btn btn-success btn-sm"
                                        onClick={() => {
                                            if (this.state.pendingUpdateType === 'studentUpdate') {
                                                const { callback } = this.state.pendingUpdateData;
                                                this.performStudentUpdate(callback);
                                            } else if (this.state.pendingUpdateType === 'bulkEligibilityUpdate') {
                                                const { isFreeLunch, callback } = this.state.pendingUpdateData;
                                                this.performBulkEligibilityUpdate(isFreeLunch, callback);
                                            }
                                        }}
                                        style={{ margin: 0, marginLeft: 5, fontSize: 14 }}>
                                        Confirm</button>
                                </div>
                            </Modal>

                            <Modal
                                isOpen={this.state.deleteModalIsOpen}
                                onRequestClose={() => this.setState({ deleteModalIsOpen: false })}
                                style={deleteStyles}
                                contentLabel="Activation">

                                <div className="modal-header">
                                    <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a
                                        Student</h4>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to delete :<b
                                        style={{ wordBreak: 'w' }}>{this.state.editStudent.firstName + ' ' + this.state.editStudent.lastName}</b>
                                    </p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ deleteModalIsOpen: false })}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <CustomSubmit id="deleteConfirm" type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} handleSubmit={(e, callback) => this.deleteStudent(e, callback)}>
                                        <i className="glyphicon glyphicon-ok"></i> Delete
                                    </CustomSubmit>
                                </div>
                            </Modal>

                            <Modal
                                isOpen={this.state.eligModalIsOpen}
                                onRequestClose={() => this.setState({ eligModalIsOpen: false, eligFreeClicked: undefined, freeEligibleReason: '' })}
                                style={deleteStyles}
                                contentLabel="Activation">

                                <div className="modal-header">
                                    <h4 className="modal-title modal-title-color" id="deleteLabel">Update Eligibility Status</h4>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        {/* {`Please confirm, if you want to update the eligibility status for the selected students to `} <b>{`${this.state.eligFreeClicked===true? 'Free': this.state.eligFreeClicked===false? 'Reduced':''} status.`}</b> */}
                                        {` This action will update eligibility status of ${this.state.selection.length} students to `}<b>{`${this.state.eligFreeClicked === true ? 'Free' : this.state.eligFreeClicked === false ? 'Reduced' : ''} status.`}</b> {`Please confirm,  if you would like to proceed ?`}
                                    </p>
                                    {
                                        this.state.eligFreeClicked ? <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='row'>
                                                    <div className='col-md-3'><label>Reason</label></div>
                                                    <div className='col-md-9'>
                                                        <select className="form-control" id={`freeEligibleReason`} value={this.state.freeEligibleReason}
                                                            onChange={(evt) => {
                                                                let freeEligibleReason = '';
                                                                freeEligibleReason = evt.target.value;
                                                                this.setState({ freeEligibleReason });
                                                            }} required>
                                                            <option></option>
                                                            {
                                                                (this.state.eligibilityCodes || []).filter(code => {
                                                                    return code.freeElig === true
                                                                }).map((code, i) => {
                                                                    return <option value={code.code}>{code.codeDesc}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null

                                    }
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ eligModalIsOpen: false, eligFreeClicked: undefined, freeEligibleReason: '' })}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <CustomSubmit id="eligConfirm" type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} handleSubmit={(e, callback) => this.changeFreeOrRedPrice(this.state.eligFreeClicked, callback)}>
                                        <i className="glyphicon glyphicon-ok"></i> Confirm
                                    </CustomSubmit>
                                </div>
                            </Modal>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <FreeReducedStudetsList selectedStudentsObj={this.state.selectionStuList} />
                                    </div></div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <section className="clearfix">
                                                <div className="tab-content">
                                                    <div className="media">
                                                        <div className="panel panel-primary">
                                                            <div className="panel-body">
                                                                <div>
                                                                    <Tabs>
                                                                        <TabList>

                                                                            <div className="button-group-section">
                                                                                <button className="btn btn-warning btn-sm pull-right"
                                                                                    style={{ marginTop: '-11px' }} onClick={() => {
                                                                                        this.exportStudents()
                                                                                    }}><i className="fa fa-file-excel-o"></i> Export</button>
                                                                                <button
                                                                                    className="btn btn-success button-sm pull-right"
                                                                                    style={{
                                                                                        marginTop: '-11px',
                                                                                        marginRight: '0px'
                                                                                    }}
                                                                                    id="addSchool"
                                                                                    onClick={() => this.openModal("addModalIsOpen", null)}
                                                                                ><i className="fa fa-plus" /> Add Student
                                                                                </button>
                                                                            </div>

                                                                            {gradeList.map((item) => {
                                                                                return <Tab onClick={() => {
                                                                                    this.state.tabIndex = item.value;
                                                                                    this.setState({ selectAll: false });
                                                                                    this.getDataByGrade(item.value);

                                                                                }}> {item.label
                                                                                    }</Tab>
                                                                            }, this)}
                                                                        </TabList>
                                                                        <TabPanel>
                                                                            <div className="row">
                                                                                <div className="col-xs-3 pull-left">
                                                                                    <input type="text" id="search"
                                                                                        className="form-control"
                                                                                        style={{
                                                                                            float: 'left',
                                                                                            margin: '5px 0'
                                                                                        }}
                                                                                        name="search"
                                                                                        placeholder="Search.."
                                                                                        onKeyUp={this.filterSchool} />
                                                                                </div>


                                                                                <div className="col-xs-9">
                                                                                    <div
                                                                                        className="pull-right button-group-section">
                                                                                        <CustomSubmit className="btn btn-warning button-xs bg-color-1"
                                                                                            handleSubmit={(e, callback) => this.bar_qr_code('BAR', callback)}
                                                                                            style={{
                                                                                                float: 'right',
                                                                                                margin: '2px',
                                                                                                fontSize: '11px'
                                                                                            }}>
                                                                                            <i className="fa fa-barcode"></i> Bar Code</CustomSubmit>
                                                                                        <CustomSubmit className="btn btn-warning button-xs bg-color-6"
                                                                                            handleSubmit={(e, callback) => this.bar_qr_code('QR', callback)}
                                                                                            style={{
                                                                                                float: 'right',
                                                                                                margin: '2px',
                                                                                                fontSize: '11px'
                                                                                            }}>
                                                                                            <i className="fa fa-qrcode"></i> QR Code</CustomSubmit>

                                                                                        {
                                                                                            getAccessLevelByModule(modEnum.BACM) ?
                                                                                                <Fragment>
                                                                                                    <CustomSubmit className="btn btn-warning button-xs bg-color-1"
                                                                                                        handleSubmit={(e, callback) => this.changeB_ACare(false, callback)}
                                                                                                        style={{
                                                                                                            float: 'right',
                                                                                                            margin: '2px',
                                                                                                            fontSize: '11px'
                                                                                                        }}>
                                                                                                        <i className="fa fa-child"></i> After Care</CustomSubmit>
                                                                                                    <CustomSubmit className="btn btn-warning button-xs bg-color-6"
                                                                                                        handleSubmit={(e, callback) => this.changeB_ACare(true, callback)}
                                                                                                        style={{
                                                                                                            float: 'right',
                                                                                                            margin: '2px',
                                                                                                            fontSize: '11px'
                                                                                                        }}>
                                                                                                        <i className="fa fa-child"></i> Before Care</CustomSubmit>
                                                                                                </Fragment> : null}
                                                                                        {
                                                                                            getAccessLevelByModule(modEnum.PR) ?
                                                                                                <CustomSubmit className="btn btn-warning button-xs"
                                                                                                    handleSubmit={(e, callback) => this.sendNotification('multiple', null, callback)}
                                                                                                    style={{
                                                                                                        float: 'right',
                                                                                                        margin: '2px',
                                                                                                        fontSize: '11px'
                                                                                                    }}>
                                                                                                    <i className="fa fa-paper-plane-o"></i> Send Link</CustomSubmit>
                                                                                                : null
                                                                                        }
                                                                                        {
                                                                                            getAccessLevelByModule(modEnum.LETM) ?
                                                                                                <Fragment>
                                                                                                    <CustomSubmit className="btn button-xs btn-info"
                                                                                                        handleSubmit={(e, callback) => {
                                                                                                            this.showFreeOrRedConform(true, callback);
                                                                                                        }}

                                                                                                        style={{
                                                                                                            float: 'right',
                                                                                                            margin: '2px',
                                                                                                            fontSize: '11px'
                                                                                                        }}>
                                                                                                        {currency_symbol()} Free Lunch
                                                                                                    </CustomSubmit>
                                                                                                    <CustomSubmit className="btn button-xs btn-success bg-color-5"
                                                                                                        handleSubmit={(e, callback) => {
                                                                                                            this.showFreeOrRedConform(false, callback);
                                                                                                        }}
                                                                                                        style={{
                                                                                                            float: 'right',
                                                                                                            margin: '2px',
                                                                                                            fontSize: '11px'
                                                                                                        }}>
                                                                                                        {currency_symbol()} Reduced Price
                                                                                                    </CustomSubmit>
                                                                                                </Fragment> : null
                                                                                        }


                                                                                    </div>
                                                                                    <div className="pull-right" style={{
                                                                                        padding: '12px',
                                                                                        fontWeight: '600',
                                                                                        fontSize: '11px'
                                                                                    }}>
                                                                                        <lable style={{ marginRight: '100px' }}>New Students: {this.state.data.filter(s => s.sisNewStudent == true).length}</lable>
                                                                                        <lable>Total Students: {this.state.data.length}</lable>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            {data ? (
                                                                                <CheckboxTable
                                                                                    ref={r => (this.checkboxTable = r)}
                                                                                    data={_.orderBy(this.state.data, ['fullName'], ['asc'])}
                                                                                    columns={this.state.columns}
                                                                                    defaultPageSize={10}
                                                                                    className="-striped -highlight"
                                                                                    {...checkboxProps}
                                                                                />) : null}
                                                                        </TabPanel>

                                                                        {gradeList.map(function (key) {
                                                                            return (
                                                                                <TabPanel>
                                                                                    <div className="row">
                                                                                        <div className="col-xs-3 pull-left">
                                                                                            <input type="text" id="search"
                                                                                                className="form-control"
                                                                                                style={{
                                                                                                    float: 'left',
                                                                                                    margin: '5px 0'
                                                                                                }}
                                                                                                name="search"
                                                                                                placeholder="Search.."
                                                                                                onKeyUp={this.filterSchool} />
                                                                                        </div>
                                                                                        <div className="col-xs-9">

                                                                                            <div
                                                                                                className="pull-right button-group-section">
                                                                                                <CustomSubmit className="btn btn-warning button-xs bg-color-1"
                                                                                                    handleSubmit={(e, callback) => this.bar_qr_code('BAR', callback)}
                                                                                                    style={{
                                                                                                        float: 'right',
                                                                                                        margin: '2px',
                                                                                                        fontSize: '11px'
                                                                                                    }}>
                                                                                                    <i className="fa fa-barcode"></i> Bar Code</CustomSubmit>
                                                                                                <CustomSubmit className="btn btn-warning button-xs bg-color-6"
                                                                                                    handleSubmit={(e, callback) => this.bar_qr_code('QR', callback)}
                                                                                                    style={{
                                                                                                        float: 'right',
                                                                                                        margin: '2px',
                                                                                                        fontSize: '11px'
                                                                                                    }}>
                                                                                                    <i className="fa fa-qrcode"></i> QR Code</CustomSubmit>
                                                                                                {
                                                                                                    getAccessLevelByModule(modEnum.BACM) ? <Fragment>
                                                                                                        <CustomSubmit className="btn btn-warning button-xs bg-color-1"
                                                                                                            handleSubmit={(e, callback) => this.changeB_ACare(false, callback)}
                                                                                                            style={{
                                                                                                                float: 'right',
                                                                                                                margin: '2px',
                                                                                                                fontSize: '11px'
                                                                                                            }}>
                                                                                                            <i className="fa fa-child"></i> After Care</CustomSubmit>
                                                                                                        <CustomSubmit className="btn btn-warning button-xs bg-color-6"
                                                                                                            handleSubmit={(e, callback) => this.changeB_ACare(true, callback)}
                                                                                                            style={{
                                                                                                                float: 'right',
                                                                                                                margin: '2px',
                                                                                                                fontSize: '11px'
                                                                                                            }}>
                                                                                                            <i className="fa fa-child"></i> Before Care</CustomSubmit>
                                                                                                    </Fragment> : null
                                                                                                }
                                                                                                {
                                                                                                    getAccessLevelByModule(modEnum.PR) ?
                                                                                                        <CustomSubmit className="btn btn-warning button-xs "
                                                                                                            handleSubmit={(e, callback) => this.sendNotification('multiple', null, callback)}
                                                                                                            style={{
                                                                                                                float: 'right',
                                                                                                                margin: '2px',
                                                                                                                fontSize: '11px'
                                                                                                            }}><i className="fa fa-paper-plane-o"></i> Send Link
                                                                                                        </CustomSubmit> : null
                                                                                                }
                                                                                                {
                                                                                                    getAccessLevelByModule(modEnum.LETM) ?
                                                                                                        <Fragment>
                                                                                                            <CustomSubmit className="btn button-xs btn-info"
                                                                                                                handleSubmit={(e, callback) => {
                                                                                                                    this.showFreeOrRedConform(true, callback);
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    float: 'right',
                                                                                                                    margin: '2px',
                                                                                                                    fontSize: '11px'
                                                                                                                }}>
                                                                                                                {currency_symbol()} Free Lunch
                                                                                                            </CustomSubmit>
                                                                                                            <CustomSubmit className="btn button-xs btn-success bg-color-5"
                                                                                                                handleSubmit={(e, callback) => {
                                                                                                                    this.showFreeOrRedConform(false, callback)
                                                                                                                }}
                                                                                                                style={{
                                                                                                                    float: 'right',
                                                                                                                    margin: '2px',
                                                                                                                    fontSize: '11px'
                                                                                                                }}>
                                                                                                                {currency_symbol()} Reduced Price
                                                                                                            </CustomSubmit>
                                                                                                        </Fragment> : null}
                                                                                            </div>
                                                                                            <div className="pull-right" style={{
                                                                                                padding: '12px',
                                                                                                fontWeight: '600',
                                                                                                fontSize: '11px'
                                                                                            }}>
                                                                                                <lable style={{ marginRight: '100px' }}>New Students: {this.state.data.filter(s => s.sisNewStudent == true).length}</lable>
                                                                                                <lable>Total
                                                                                                    Students: {this.state.data.length}</lable>
                                                                                            </div>
                                                                                        </div>


                                                                                    </div>
                                                                                    {data ? (
                                                                                        <CheckboxTable
                                                                                            ref={r => (this.checkboxTable = r)}
                                                                                            data={_.orderBy(this.state.data, ['fullName'], ['asc'])}
                                                                                            columns={this.state.columns}
                                                                                            defaultPageSize={10}
                                                                                            className="-striped -highlight"
                                                                                            {...checkboxProps}
                                                                                        />) : null}
                                                                                </TabPanel>)
                                                                        }, this)}
                                                                    </Tabs>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <p className="App-intro">
                                        <a href="javascript:void(0);" onClick={() => this.handleClick()}> Deleted
                                            Students
                                        </a>
                                    </p>
                                    <ToggleDisplay show={this.state.show}>
                                        <p><b><i> These are the deleted students. Click on restore to undo the
                                            action.</i></b>
                                            {/*<span className="pull-right"><a>Restore all</a></span>*/}</p>
                                        <div className="table-responsive ">
                                            <table className="table table-dark" id="schoolData">
                                                <thead>
                                                    <tr className="">
                                                        <th>Student First Name</th>
                                                        <th>Student Last Name</th>
                                                        <th>Student ID</th>
                                                        <th>Grade</th>
                                                        <th>Parent Email ID</th>
                                                        <th>Parent phone</th>
                                                        <th className="text-center" colSpan="2">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/*<div id="noSchool" style={{display: 'none'}} className="noSchool">*/}
                                                    {/*<span>Oops, We found nothing. Try Adding new students.</span>*/}
                                                    {/*</div>*/}
                                                    {
                                                        this.state.deletedStudents.map(col =>
                                                            <tr className="table">
                                                                <td>{col.firstName}</td>
                                                                <td>{col.lastName}</td>
                                                                <td>{col.studentId}</td>
                                                                <td>{col.gradeName}</td>
                                                                <td>{col.parentuser.userName}</td>
                                                                <td>{col.mobileNo}</td>
                                                                <td className="actions text-center">
                                                                    <a href="javascript:void(0)"
                                                                        onClick={() => this.activateStudent(col)}>Restore</a>
                                                                </td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>

                                        </div>
                                    </ToggleDisplay>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }

}
ManageSchool.contextTypes = {
    router: PropTypes.object.isRequired
};
export default ManageSchool;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/manageSchool.jsx